<template>
  <div class="flex items-center min-h-screen p-6 bg-gray-50 dark:bg-gray-900">
    <div
      class="flex-1 h-full max-w-4xl mx-auto overflow-hidden bg-white rounded-lg shadow-xl dark:bg-gray-800"
    >
      <div class="flex flex-col overflow-y-auto md:flex-row">
        <div
          class="h-32 md:h-auto md:w-1/2 pl-0 md:pl-12 flex items-center justify-center"
        >
          <svg
            viewBox="0 0 500 405"
            class="md:h-80 h-28 md:mt-0 mt-20 md:mb-0 mb-10"
            version="1.2"
          >
            <g
              transform="matrix(1.3333333,0,0,-1.3333333,0,1056)"
              inkscape:label="LOGO EDITABLE"
              inkscape:groupmode="layer"
              id="g10"
            >
              <g
                transform="matrix(1.1358601,0,0,1.1354533,4.2026824,537.34315)"
                id="g582"
              >
                <path
                  id="circle3"
                  d="M 0,0 H 2.548 C 3.672,0 4.446,0.226 4.871,0.678 5.295,1.13 5.508,1.876 5.508,2.918 V 7.11 c 0,2.165 -0.987,3.248 -2.96,3.248 H 0 Z m 2.836,13.934 c 1.973,0 3.528,-0.562 4.665,-1.685 1.137,-1.124 1.707,-2.686 1.707,-4.687 v -4.48 c 0,-1.288 -0.193,-2.288 -0.576,-3 C 8.248,-0.631 7.687,-1.151 6.947,-1.48 7.741,-1.809 8.358,-2.344 8.796,-3.083 9.234,-3.823 9.454,-4.851 9.454,-6.166 V -18.251 H 5.713 v 12.208 c 0,1.014 -0.199,1.733 -0.595,2.158 C 4.72,-3.46 3.946,-3.248 2.795,-3.248 H 0 v -15.003 h -3.7 v 32.185 z"
                ></path>
              </g>
              <path
                id="circle3"
                d="m 23.157802,516.61988 h -4.295823 v 36.54457 h 4.295823 z"
              ></path>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,30.34791,553.16411)"
                id="g588"
              >
                <path
                  id="circle3"
                  d="M 0,0 3.658,-23.923 7.399,0 h 3.658 L 5.508,-32.185 H 1.768 L -3.7,0 Z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,57.987362,553.16411)"
                id="g592"
              >
                <path
                  id="circle3"
                  d="M 0,0 V -3.658 H -6.865 V -13.77 h 4.851 v -3.658 H -6.865 V -28.526 H 0 v -3.659 H -10.646 V 0 Z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,65.691106,537.34315)"
                id="g596"
              >
                <path
                  id="circle3"
                  d="M 0,0 H 2.548 C 3.672,0 4.446,0.226 4.871,0.678 5.295,1.13 5.508,1.876 5.508,2.918 V 7.11 c 0,2.165 -0.987,3.248 -2.96,3.248 H 0 Z m 2.836,13.934 c 1.973,0 3.528,-0.562 4.665,-1.685 1.137,-1.124 1.707,-2.686 1.707,-4.687 v -4.48 c 0,-1.288 -0.193,-2.288 -0.576,-3 C 8.248,-0.631 7.687,-1.151 6.947,-1.48 7.741,-1.809 8.358,-2.344 8.796,-3.083 9.234,-3.823 9.454,-4.851 9.454,-6.166 V -18.251 H 5.713 v 12.208 c 0,1.014 -0.199,1.733 -0.595,2.158 C 4.72,-3.46 3.946,-3.248 2.795,-3.248 H 0 v -15.003 h -3.7 v 32.185 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,84.366237,523.34074)"
                id="g600"
              >
                <path
                  id="circle3"
                  d="m 0,0 c 0,-0.932 0.267,-1.638 0.802,-2.117 0.534,-0.48 1.226,-0.719 2.075,-0.719 0.85,0 1.542,0.239 2.076,0.719 0.534,0.479 0.802,1.185 0.802,2.117 v 20.347 c 0,0.931 -0.268,1.637 -0.802,2.117 -0.534,0.479 -1.226,0.72 -2.076,0.72 -0.849,0 -1.541,-0.241 -2.075,-0.72 C 0.267,21.984 0,21.278 0,20.347 Z M 9.495,-0.041 C 9.495,-1.055 9.324,-1.959 8.981,-2.754 8.639,-3.549 8.166,-4.228 7.563,-4.788 6.96,-5.351 6.254,-5.775 5.446,-6.062 4.638,-6.351 3.782,-6.494 2.877,-6.494 c -0.932,0 -1.802,0.143 -2.61,0.432 -0.809,0.287 -1.507,0.711 -2.096,1.274 -0.59,0.56 -1.055,1.239 -1.398,2.034 -0.343,0.795 -0.514,1.699 -0.514,2.713 v 20.429 c 0,1.013 0.171,1.918 0.514,2.713 0.343,0.795 0.808,1.465 1.398,2.014 0.589,0.548 1.287,0.973 2.096,1.275 0.808,0.3 1.678,0.452 2.61,0.452 0.905,0 1.761,-0.152 2.569,-0.452 0.808,-0.302 1.514,-0.727 2.117,-1.275 0.603,-0.549 1.076,-1.219 1.418,-2.014 0.343,-0.795 0.514,-1.7 0.514,-2.713 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,99.446257,542.10343)"
                id="g604"
              >
                <path
                  id="circle3"
                  d="m 0,0 h -1.315 l 0.37,8.262 c 0.027,0.658 0.205,1.198 0.534,1.624 0.329,0.425 0.849,0.636 1.562,0.636 0.74,0 1.288,-0.219 1.644,-0.657 C 3.151,9.427 3.33,8.905 3.33,8.303 3.33,7.81 3.179,7.248 2.877,6.618 Z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,113.45266,553.81836)"
                id="g608"
              >
                <path
                  id="circle3"
                  d="M 0,0 C 1.945,0 3.466,-0.576 4.562,-1.727 5.658,-2.878 6.207,-4.398 6.207,-6.289 V -7.44 H 2.713 v 0.863 c 0,0.931 -0.247,1.671 -0.74,2.22 -0.494,0.547 -1.179,0.822 -2.055,0.822 -1.014,0 -1.761,-0.336 -2.24,-1.007 -0.48,-0.672 -0.72,-1.487 -0.72,-2.446 0,-0.795 0.144,-1.541 0.432,-2.241 0.288,-0.698 0.705,-1.431 1.254,-2.199 0.356,-0.52 0.801,-1.124 1.335,-1.808 0.535,-0.685 1.083,-1.405 1.645,-2.158 0.561,-0.754 1.103,-1.494 1.623,-2.219 0.521,-0.727 0.973,-1.392 1.357,-1.994 0.63,-1.014 1.089,-1.973 1.376,-2.877 0.289,-0.905 0.432,-1.947 0.432,-3.124 0,-2.384 -0.52,-4.269 -1.562,-5.653 -1.041,-1.384 -2.671,-2.075 -4.891,-2.075 -1.069,0 -2.022,0.164 -2.857,0.493 -0.836,0.329 -1.541,0.774 -2.117,1.336 -0.575,0.562 -1.021,1.226 -1.336,1.993 -0.315,0.767 -0.472,1.589 -0.472,2.467 v 1.727 l 3.493,-0.905 v -0.781 c 0,-0.767 0.267,-1.438 0.802,-2.015 0.534,-0.575 1.28,-0.863 2.24,-0.863 1.041,0 1.815,0.329 2.323,0.988 0.507,0.657 0.76,1.588 0.76,2.794 0,0.74 -0.117,1.494 -0.349,2.261 -0.234,0.767 -0.652,1.616 -1.254,2.548 -0.302,0.466 -0.678,0.987 -1.13,1.563 -0.453,0.575 -0.925,1.177 -1.418,1.808 -0.494,0.63 -0.98,1.268 -1.46,1.911 -0.479,0.644 -0.911,1.268 -1.294,1.87 -0.932,1.481 -1.57,2.788 -1.912,3.926 -0.343,1.137 -0.514,2.227 -0.514,3.268 0,2.137 0.596,3.829 1.788,5.077 C -3.556,-0.624 -1.973,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,136.8432,523.29408)"
                id="g612"
              >
                <path
                  id="circle3"
                  d="m 0,0 c 0,-0.932 0.253,-1.631 0.76,-2.097 0.507,-0.466 1.172,-0.698 1.994,-0.698 0.822,0 1.521,0.232 2.096,0.698 C 5.426,-1.631 5.713,-0.932 5.713,0 V 8.55 H 2.507 v 3.412 H 9.002 V -5.878 H 6.659 L 6.495,-4.48 C 5.974,-5.056 5.343,-5.528 4.604,-5.898 3.864,-6.269 3.014,-6.453 2.055,-6.453 c -1.644,0 -3.008,0.568 -4.09,1.706 -1.083,1.137 -1.624,2.691 -1.624,4.665 v 20.594 c 0,0.986 0.158,1.87 0.473,2.65 0.315,0.781 0.761,1.452 1.336,2.015 0.576,0.561 1.26,0.986 2.056,1.274 0.794,0.287 1.67,0.432 2.63,0.432 1.891,0 3.412,-0.57 4.563,-1.706 1.151,-1.138 1.726,-2.693 1.726,-4.665 v -1.07 H 5.631 v 0.987 c 0,0.931 -0.254,1.631 -0.76,2.096 -0.508,0.466 -1.172,0.7 -1.994,0.7 C 2,23.225 1.301,22.991 0.781,22.525 0.26,22.06 0,21.36 0,20.429 Z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,155.5649,553.16411)"
                id="g616"
              >
                <path
                  id="circle3"
                  d="m 0,0 v -28.526 h 6.042 v -3.659 H -3.782 V 0 Z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,168.82471,523.34074)"
                id="g620"
              >
                <path
                  id="circle3"
                  d="m 0,0 c 0,-0.932 0.267,-1.638 0.802,-2.117 0.534,-0.48 1.225,-0.719 2.075,-0.719 0.85,0 1.542,0.239 2.076,0.719 0.534,0.479 0.802,1.185 0.802,2.117 v 20.347 c 0,0.931 -0.268,1.637 -0.802,2.117 -0.534,0.479 -1.226,0.72 -2.076,0.72 -0.85,0 -1.541,-0.241 -2.075,-0.72 C 0.267,21.984 0,21.278 0,20.347 Z M 9.495,-0.041 C 9.495,-1.055 9.324,-1.959 8.981,-2.754 8.639,-3.549 8.166,-4.228 7.563,-4.788 6.96,-5.351 6.254,-5.775 5.446,-6.062 4.638,-6.351 3.781,-6.494 2.877,-6.494 c -0.932,0 -1.802,0.143 -2.61,0.432 -0.809,0.287 -1.507,0.711 -2.096,1.274 -0.59,0.56 -1.055,1.239 -1.398,2.034 -0.343,0.795 -0.514,1.699 -0.514,2.713 v 20.429 c 0,1.013 0.171,1.918 0.514,2.713 0.343,0.795 0.808,1.465 1.398,2.014 0.589,0.548 1.287,0.973 2.096,1.275 0.808,0.3 1.678,0.452 2.61,0.452 0.904,0 1.761,-0.152 2.569,-0.452 0.808,-0.302 1.514,-0.727 2.117,-1.275 0.603,-0.549 1.076,-1.219 1.418,-2.014 0.343,-0.795 0.514,-1.7 0.514,-2.713 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,187.87251,520.6806)"
                id="g624"
              >
                <path
                  id="circle3"
                  d="m 0,0 h 2.878 c 1.973,0 2.959,1.096 2.959,3.288 v 4.933 c 0,1.151 -0.22,1.966 -0.657,2.446 -0.439,0.479 -1.206,0.719 -2.302,0.719 H 0 Z m 0,14.633 h 2.631 c 1.041,0 1.781,0.22 2.22,0.658 0.438,0.438 0.658,1.219 0.658,2.343 v 4.151 c 0,1.014 -0.234,1.809 -0.699,2.385 -0.466,0.575 -1.22,0.863 -2.261,0.863 H 0 Z m 2.837,13.975 c 1.973,0 3.527,-0.561 4.665,-1.684 1.137,-1.124 1.706,-2.687 1.706,-4.687 v -4.48 C 9.208,16.441 9.016,15.421 8.633,14.695 8.248,13.969 7.659,13.441 6.865,13.112 7.741,12.783 8.413,12.235 8.879,11.468 9.345,10.7 9.578,9.604 9.578,8.18 V 3.042 C 9.578,0.904 9.002,-0.733 7.852,-1.87 6.7,-3.008 5.139,-3.576 3.165,-3.576 h -6.864 v 32.184 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,206.64203,525.48743)"
                id="g628"
              >
                <path
                  id="circle3"
                  d="M 0,0 H 5.016 L 2.467,16.113 Z M 4.316,24.375 9.906,-7.81 H 6.248 L 5.509,-3.165 H -0.493 L -1.191,-7.81 H -4.85 l 5.426,32.185 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,225.17734,553.16411)"
                id="g632"
              >
                <path
                  id="circle3"
                  d="m 0,0 v -28.526 h 6.042 v -3.659 H -3.782 V 0 Z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,247.82025,523.29408)"
                id="g636"
              >
                <path
                  id="circle3"
                  d="m 0,0 c 0,-0.932 0.253,-1.631 0.761,-2.097 0.507,-0.466 1.171,-0.698 1.993,-0.698 0.822,0 1.493,0.232 2.015,0.698 0.519,0.466 0.78,1.165 0.78,2.097 v 0.658 l 3.494,0.904 v -1.644 c 0,-0.986 -0.171,-1.87 -0.514,-2.651 C 8.187,-3.515 7.728,-4.187 7.152,-4.747 6.577,-5.31 5.898,-5.734 5.117,-6.021 4.337,-6.31 3.494,-6.453 2.59,-6.453 c -0.878,0 -1.699,0.143 -2.467,0.432 -0.768,0.287 -1.438,0.711 -2.014,1.274 -0.575,0.56 -1.027,1.232 -1.356,2.014 -0.329,0.781 -0.493,1.665 -0.493,2.651 v 20.594 c 0,0.986 0.164,1.87 0.493,2.65 0.329,0.781 0.781,1.452 1.356,2.015 0.576,0.561 1.26,0.986 2.055,1.274 0.795,0.287 1.672,0.432 2.631,0.432 1.918,0 3.438,-0.57 4.562,-1.706 1.124,-1.138 1.686,-2.693 1.686,-4.665 v -1.07 H 5.549 v 0.987 c 0,0.931 -0.24,1.631 -0.719,2.096 -0.48,0.466 -1.144,0.7 -1.994,0.7 -0.877,0 -1.568,-0.234 -2.075,-0.7 C 0.253,22.06 0,21.36 0,20.429 Z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,265.14212,523.34074)"
                id="g640"
              >
                <path
                  id="circle3"
                  d="m 0,0 c 0,-0.932 0.268,-1.638 0.802,-2.117 0.534,-0.48 1.225,-0.719 2.075,-0.719 0.85,0 1.542,0.239 2.076,0.719 0.534,0.479 0.802,1.185 0.802,2.117 v 20.347 c 0,0.931 -0.268,1.637 -0.802,2.117 -0.534,0.479 -1.226,0.72 -2.076,0.72 -0.85,0 -1.541,-0.241 -2.075,-0.72 C 0.268,21.984 0,21.278 0,20.347 Z M 9.495,-0.041 C 9.495,-1.055 9.324,-1.959 8.981,-2.754 8.639,-3.549 8.166,-4.228 7.563,-4.788 6.96,-5.351 6.254,-5.775 5.446,-6.062 4.638,-6.351 3.781,-6.494 2.877,-6.494 c -0.932,0 -1.802,0.143 -2.609,0.432 -0.809,0.287 -1.508,0.711 -2.097,1.274 -0.59,0.56 -1.056,1.239 -1.398,2.034 -0.342,0.795 -0.513,1.699 -0.513,2.713 v 20.429 c 0,1.013 0.171,1.918 0.513,2.713 0.342,0.795 0.808,1.465 1.398,2.014 0.589,0.548 1.288,0.973 2.097,1.275 0.807,0.3 1.677,0.452 2.609,0.452 0.904,0 1.761,-0.152 2.569,-0.452 0.808,-0.302 1.514,-0.727 2.117,-1.275 0.603,-0.549 1.076,-1.219 1.418,-2.014 0.343,-0.795 0.514,-1.7 0.514,-2.713 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,284.65802,553.16411)"
                id="g644"
              >
                <path
                  id="circle3"
                  d="M 0,0 5.015,-25.525 10.317,0 H 14.1 v -32.185 h -3.371 v 20.758 L 6.782,-32.185 H 3.289 l -4.028,21.046 V -32.185 H -4.11 V 0 Z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,309.26313,535.19533)"
                id="g648"
              >
                <path
                  id="circle3"
                  d="m 0,0 h 2.589 c 1.973,0 2.96,1.165 2.96,3.494 v 5.18 c 0,2.328 -0.987,3.493 -2.96,3.493 H 0 Z m 2.877,15.825 c 1.973,0 3.535,-0.602 4.685,-1.808 1.152,-1.206 1.727,-3.07 1.727,-5.59 V 3.741 C 9.289,1.22 8.714,-0.644 7.562,-1.85 6.412,-3.056 4.85,-3.658 2.877,-3.658 H 0 v -12.701 h -3.782 v 32.184 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,325.37042,525.48743)"
                id="g652"
              >
                <path
                  id="circle3"
                  d="M 0,0 H 5.016 L 2.467,16.113 Z M 4.316,24.375 9.906,-7.81 H 6.248 L 5.509,-3.165 H -0.493 L -1.191,-7.81 H -4.85 l 5.426,32.185 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,344.27852,553.16411)"
                id="g656"
              >
                <path
                  id="circle3"
                  d="M 0,0 5.467,-22.196 V 0 H 8.756 V -32.185 H 5.385 L -0.821,-8.508 V -32.185 H -4.11 V 0 Z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,361.32085,553.16411)"
                id="g660"
              >
                <path
                  id="circle3"
                  d="M 0,0 4.151,-12.495 8.385,0 h 3.658 L 6.001,-17.141 V -32.185 H 2.22 v 15.044 L -3.823,0 Z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,261.99352,634.2533)"
                id="g664"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -0.988,0 -1.79,0.801 -1.79,1.79 0,0.988 0.802,1.789 1.79,1.789 0.988,0 1.79,-0.801 1.79,-1.789 C 1.79,0.801 0.988,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,249.18397,640.61468)"
                id="g668"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -1.714,0 -3.104,1.39 -3.104,3.104 0,1.714 1.39,3.104 3.104,3.104 1.714,0 3.104,-1.39 3.104,-3.104 C 3.104,1.39 1.714,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,238.10206,649.68025)"
                id="g672"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.267,0 -4.105,1.838 -4.105,4.105 0,2.267 1.838,4.104 4.105,4.104 2.267,0 4.105,-1.837 4.105,-4.104 C 4.105,1.838 2.267,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,228.22008,660.20488)"
                id="g676"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.68,0 -4.853,2.173 -4.853,4.853 0,2.68 2.173,4.853 4.853,4.853 2.68,0 4.853,-2.173 4.853,-4.853 C 4.853,2.173 2.68,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,219.28268,671.7797)"
                id="g680"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.952,0 -5.345,2.393 -5.345,5.345 0,2.952 2.393,5.345 5.345,5.345 2.952,0 5.345,-2.393 5.345,-5.345 C 5.345,2.393 2.952,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,211.16843,684.13377)"
                id="g684"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -3.116,0 -5.642,2.526 -5.642,5.642 0,3.116 2.526,5.642 5.642,5.642 3.116,0 5.642,-2.526 5.642,-5.642 C 5.642,2.526 3.116,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,203.81011,697.16469)"
                id="g688"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -3.175,0 -5.75,2.574 -5.75,5.75 0,3.175 2.575,5.749 5.75,5.749 3.175,0 5.75,-2.574 5.75,-5.749 C 5.75,2.574 3.175,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,197.19906,710.82464)"
                id="g692"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -3.121,0 -5.651,2.53 -5.651,5.651 0,3.121 2.53,5.651 5.651,5.651 3.121,0 5.651,-2.53 5.651,-5.651 C 5.651,2.53 3.121,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,191.3947,725.07345)"
                id="g696"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.959,0 -5.358,2.399 -5.358,5.358 0,2.958 2.399,5.357 5.358,5.357 2.959,0 5.358,-2.399 5.358,-5.357 C 5.358,2.399 2.959,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,186.52334,739.89316)"
                id="g700"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.688,0 -4.867,2.179 -4.867,4.867 0,2.688 2.179,4.867 4.867,4.867 2.688,0 4.867,-2.179 4.867,-4.867 C 4.867,2.179 2.688,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,182.81441,755.34475)"
                id="g704"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.276,0 -4.121,1.845 -4.121,4.121 0,2.276 1.845,4.121 4.121,4.121 2.276,0 4.121,-1.845 4.121,-4.121 C 4.121,1.845 2.276,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,180.75215,771.40608)"
                id="g708"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -1.722,0 -3.119,1.396 -3.119,3.119 0,1.722 1.397,3.118 3.119,3.118 1.722,0 3.119,-1.396 3.119,-3.118 C 3.119,1.396 1.722,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,181.60472,787.91239)"
                id="g712"
              >
                <path
                  id="circle2"
                  d="M 0,0 C -0.994,0 -1.8,0.806 -1.8,1.8 -1.8,2.794 -0.994,3.6 0,3.6 0.994,3.6 1.8,2.794 1.8,1.8 1.8,0.806 0.994,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,253.86621,624.49181)"
                id="g716"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -0.928,0 -1.681,0.752 -1.681,1.681 0,0.928 0.753,1.68 1.681,1.68 0.928,0 1.681,-0.752 1.681,-1.68 C 1.681,0.752 0.928,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,240.68319,629.9396)"
                id="g720"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -1.63,0 -2.952,1.322 -2.952,2.952 0,1.631 1.322,2.952 2.952,2.952 1.63,0 2.952,-1.321 2.952,-2.952 C 2.952,1.322 1.63,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,229.20101,638.34763)"
                id="g724"
              >
                <path
                  id="circle2"
                  d="M 0,0 C -2.174,0 -3.936,1.762 -3.936,3.936 -3.936,6.11 -2.174,7.872 0,7.872 2.174,7.872 3.936,6.11 3.936,3.936 3.936,1.762 2.174,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,218.95282,648.36574)"
                id="g728"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.578,0 -4.668,2.09 -4.668,4.668 0,2.579 2.09,4.669 4.668,4.669 2.578,0 4.668,-2.09 4.668,-4.669 C 4.668,2.09 2.578,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,209.68034,659.44299)"
                id="g732"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.879,0 -5.214,2.334 -5.214,5.214 0,2.879 2.335,5.214 5.214,5.214 2.879,0 5.214,-2.335 5.214,-5.214 C 5.214,2.334 2.879,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,201.24636,671.38274)"
                id="g736"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -3.064,0 -5.549,2.484 -5.549,5.549 0,3.064 2.485,5.548 5.549,5.548 3.064,0 5.549,-2.484 5.549,-5.548 C 5.549,2.484 3.064,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,193.58464,684.00807)"
                id="g740"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -3.155,0 -5.713,2.558 -5.713,5.713 0,3.156 2.558,5.714 5.713,5.714 3.155,0 5.713,-2.558 5.713,-5.714 C 5.713,2.558 3.155,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,186.66407,697.2327)"
                id="g744"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -3.157,0 -5.717,2.559 -5.717,5.717 0,3.157 2.56,5.716 5.717,5.716 3.157,0 5.717,-2.559 5.717,-5.716 C 5.717,2.559 3.157,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,180.50555,711.01869)"
                id="g748"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -3.069,0 -5.557,2.488 -5.557,5.557 0,3.069 2.488,5.557 5.557,5.557 3.069,0 5.557,-2.488 5.557,-5.557 C 5.557,2.488 3.069,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,175.19222,725.35209)"
                id="g752"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.887,0 -5.227,2.34 -5.227,5.227 0,2.887 2.34,5.228 5.227,5.228 2.887,0 5.227,-2.341 5.227,-5.228 C 5.227,2.34 2.887,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,170.87039,740.25889)"
                id="g756"
              >
                <path
                  id="circle2"
                  d="M 0,0 C -2.587,0 -4.685,2.098 -4.685,4.685 -4.685,7.272 -2.587,9.37 0,9.37 2.587,9.37 4.685,7.272 4.685,4.685 4.685,2.098 2.587,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,167.80175,755.6989)"
                id="g760"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.182,0 -3.951,1.769 -3.951,3.951 0,2.183 1.769,3.952 3.951,3.952 2.182,0 3.951,-1.769 3.951,-3.952 C 3.951,1.769 2.182,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,166.5247,771.68472)"
                id="g764"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -1.638,0 -2.966,1.328 -2.966,2.966 0,1.638 1.328,2.966 2.966,2.966 1.638,0 2.966,-1.328 2.966,-2.966 C 2.966,1.328 1.638,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,168.38308,787.89933)"
                id="g768"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -0.934,0 -1.69,0.757 -1.69,1.69 0,0.934 0.756,1.691 1.69,1.691 0.934,0 1.69,-0.757 1.69,-1.691 C 1.69,0.757 0.934,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,240.74521,615.69863)"
                id="g772"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -0.928,0 -1.681,0.752 -1.681,1.681 0,0.928 0.753,1.68 1.681,1.68 0.928,0 1.681,-0.752 1.681,-1.68 C 1.681,0.752 0.928,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,227.25006,621.30993)"
                id="g776"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -1.63,0 -2.952,1.322 -2.952,2.952 0,1.631 1.322,2.952 2.952,2.952 1.63,0 2.952,-1.321 2.952,-2.952 C 2.952,1.322 1.63,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,215.49595,629.94369)"
                id="g780"
              >
                <path
                  id="circle2"
                  d="M 0,0 C -2.174,0 -3.936,1.762 -3.936,3.936 -3.936,6.11 -2.174,7.872 0,7.872 2.174,7.872 3.936,6.11 3.936,3.936 3.936,1.762 2.174,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,205.00503,640.21897)"
                id="g784"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.578,0 -4.668,2.09 -4.668,4.668 0,2.579 2.09,4.669 4.668,4.669 2.578,0 4.668,-2.09 4.668,-4.669 C 4.668,2.09 2.578,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,195.51299,651.57339)"
                id="g788"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.879,0 -5.214,2.334 -5.214,5.214 0,2.879 2.335,5.214 5.214,5.214 2.879,0 5.214,-2.335 5.214,-5.214 C 5.214,2.334 2.879,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,186.87943,663.80518)"
                id="g792"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -3.064,0 -5.549,2.484 -5.549,5.549 0,3.064 2.485,5.548 5.549,5.548 3.064,0 5.549,-2.484 5.549,-5.548 C 5.549,2.484 3.064,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,179.03631,676.73413)"
                id="g796"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -3.155,0 -5.713,2.558 -5.713,5.713 0,3.156 2.558,5.714 5.713,5.714 3.155,0 5.713,-2.558 5.713,-5.714 C 5.713,2.558 3.155,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,171.95196,690.27214)"
                id="g800"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -3.157,0 -5.717,2.559 -5.717,5.717 0,3.157 2.56,5.716 5.717,5.716 3.157,0 5.717,-2.559 5.717,-5.716 C 5.717,2.559 3.157,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,165.64782,704.38061)"
                id="g804"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -3.069,0 -5.557,2.488 -5.557,5.557 0,3.069 2.488,5.557 5.557,5.557 3.069,0 5.557,-2.488 5.557,-5.557 C 5.557,2.488 3.069,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,160.20887,719.04487)"
                id="g808"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.887,0 -5.227,2.34 -5.227,5.227 0,2.887 2.34,5.228 5.227,5.228 2.887,0 5.227,-2.341 5.227,-5.228 C 5.227,2.34 2.887,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,155.78503,734.29026)"
                id="g812"
              >
                <path
                  id="circle2"
                  d="M 0,0 C -2.587,0 -4.685,2.098 -4.685,4.685 -4.685,7.272 -2.587,9.37 0,9.37 2.587,9.37 4.685,7.272 4.685,4.685 4.685,2.098 2.587,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,152.64415,750.07658)"
                id="g816"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -2.182,0 -3.951,1.769 -3.951,3.951 0,2.183 1.769,3.952 3.951,3.952 2.182,0 3.951,-1.769 3.951,-3.952 C 3.951,1.769 2.182,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,151.33768,766.41451)"
                id="g820"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -1.638,0 -2.966,1.328 -2.966,2.966 0,1.638 1.328,2.966 2.966,2.966 1.638,0 2.966,-1.328 2.966,-2.966 C 2.966,1.328 1.638,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,153.24286,782.9818)"
                id="g824"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -0.934,0 -1.69,0.757 -1.69,1.69 0,0.934 0.756,1.691 1.69,1.691 0.934,0 1.69,-0.757 1.69,-1.691 C 1.69,0.757 0.934,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,267.78459,644.5748)"
                id="g828"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -1.051,0 -1.903,0.852 -1.903,1.903 0,1.052 0.852,1.904 1.903,1.904 1.051,0 1.903,-0.852 1.903,-1.904 C 1.903,0.852 1.051,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,255.13497,651.28647)"
                id="g832"
              >
                <path
                  id="circle1"
                  d="M 0,0 C -1.811,0 -3.279,1.468 -3.279,3.279 -3.279,5.09 -1.811,6.558 0,6.558 1.811,6.558 3.279,5.09 3.279,3.279 3.279,1.468 1.811,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,244.25434,660.65702)"
                id="g836"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -2.374,0 -4.299,1.925 -4.299,4.299 0,2.375 1.925,4.299 4.299,4.299 2.374,0 4.299,-1.924 4.299,-4.299 C 4.299,1.925 2.374,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,234.58873,671.50787)"
                id="g840"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -2.772,0 -5.02,2.247 -5.02,5.019 0,2.773 2.248,5.02 5.02,5.02 2.772,0 5.02,-2.247 5.02,-5.02 C 5.02,2.247 2.772,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,225.89509,683.38233)"
                id="g844"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -3.034,0 -5.494,2.46 -5.494,5.494 0,3.035 2.46,5.495 5.494,5.495 3.034,0 5.494,-2.46 5.494,-5.495 C 5.494,2.46 3.034,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,218.05992,696.1103)"
                id="g848"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -3.152,0 -5.708,2.556 -5.708,5.708 0,3.152 2.556,5.708 5.708,5.708 3.152,0 5.708,-2.556 5.708,-5.708 C 5.708,2.556 3.152,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,211.03463,709.53431)"
                id="g852"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -3.154,0 -5.711,2.557 -5.711,5.711 0,3.154 2.557,5.711 5.711,5.711 3.154,0 5.711,-2.557 5.711,-5.711 C 5.711,2.557 3.154,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,204.84362,723.60599)"
                id="g856"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -3.041,0 -5.506,2.465 -5.506,5.506 0,3.041 2.465,5.507 5.506,5.507 3.041,0 5.506,-2.466 5.506,-5.507 C 5.506,2.465 3.041,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,199.60265,738.36245)"
                id="g860"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -2.78,0 -5.034,2.254 -5.034,5.034 0,2.781 2.254,5.035 5.034,5.035 2.78,0 5.034,-2.254 5.034,-5.035 C 5.034,2.254 2.78,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,195.52741,753.77124)"
                id="g864"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -2.384,0 -4.317,1.933 -4.317,4.317 0,2.384 1.933,4.316 4.317,4.316 2.384,0 4.317,-1.932 4.317,-4.316 C 4.317,1.933 2.384,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,193.07963,769.88173)"
                id="g868"
              >
                <path
                  id="circle1"
                  d="M 0,0 C -1.82,0 -3.295,1.475 -3.295,3.295 -3.295,5.115 -1.82,6.59 0,6.59 1.82,6.59 3.295,5.115 3.295,3.295 3.295,1.475 1.82,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,193.49377,786.56778)"
                id="g872"
              >
                <path
                  id="circle1"
                  d="M 0,0 C -1.057,0 -1.913,0.857 -1.913,1.913 -1.913,2.97 -1.057,3.827 0,3.827 1.057,3.827 1.913,2.97 1.913,1.913 1.913,0.857 1.057,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,273.44321,655.98611)"
                id="g876"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -1.122,0 -2.032,0.91 -2.032,2.032 0,1.122 0.91,2.031 2.032,2.031 1.122,0 2.032,-0.909 2.032,-2.031 C 2.032,0.91 1.122,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,261.35301,662.80098)"
                id="g880"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -1.919,0 -3.474,1.555 -3.474,3.474 0,1.919 1.555,3.475 3.474,3.475 1.919,0 3.474,-1.556 3.474,-3.475 C 3.474,1.555 1.919,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,251.00952,672.18221)"
                id="g884"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -2.489,0 -4.507,2.018 -4.507,4.507 0,2.489 2.018,4.507 4.507,4.507 2.489,0 4.507,-2.018 4.507,-4.507 C 4.507,2.018 2.489,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,241.87403,682.99854)"
                id="g888"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -2.88,0 -5.214,2.334 -5.214,5.214 0,2.879 2.334,5.214 5.214,5.214 2.879,0 5.214,-2.335 5.214,-5.214 C 5.214,2.334 2.879,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,233.71253,694.88901)"
                id="g892"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -3.094,0 -5.603,2.509 -5.603,5.603 0,3.095 2.509,5.603 5.603,5.603 3.095,0 5.603,-2.508 5.603,-5.603 C 5.603,2.509 3.095,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,226.4311,707.59394)"
                id="g896"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -3.175,0 -5.75,2.574 -5.75,5.75 0,3.175 2.575,5.749 5.75,5.749 3.175,0 5.75,-2.574 5.75,-5.749 C 5.75,2.574 3.175,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,220.00758,721.07608)"
                id="g900"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -3.099,0 -5.612,2.513 -5.612,5.612 0,3.099 2.513,5.612 5.612,5.612 3.099,0 5.612,-2.513 5.612,-5.612 C 5.612,2.513 3.099,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,214.53058,735.24949)"
                id="g904"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -2.887,0 -5.227,2.34 -5.227,5.227 0,2.887 2.34,5.228 5.227,5.228 2.887,0 5.227,-2.341 5.227,-5.228 C 5.227,2.34 2.887,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,210.19375,750.18457)"
                id="g908"
              >
                <path
                  id="circle1"
                  d="M 0,0 C -2.498,0 -4.522,2.025 -4.522,4.522 -4.522,7.02 -2.498,9.045 0,9.045 2.498,9.045 4.522,7.02 4.522,4.522 4.522,2.025 2.498,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,207.42146,765.87801)"
                id="g912"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -1.927,0 -3.489,1.562 -3.489,3.489 0,1.927 1.562,3.489 3.489,3.489 1.927,0 3.489,-1.562 3.489,-3.489 C 3.489,1.562 1.927,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,207.37273,782.28054)"
                id="g916"
              >
                <path
                  id="circle1"
                  d="M 0,0 C -1.128,0 -2.042,0.914 -2.042,2.042 -2.042,3.17 -1.128,4.085 0,4.085 1.128,4.085 2.042,3.17 2.042,2.042 2.042,0.914 1.128,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,277.65146,671.49788)"
                id="g920"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -1.305,0 -2.362,1.058 -2.362,2.363 0,1.304 1.057,2.362 2.362,2.362 1.305,0 2.363,-1.058 2.363,-2.362 C 2.363,1.058 1.305,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,265.92223,679.1506)"
                id="g924"
              >
                <path
                  id="circle1"
                  d="M 0,0 C -2.174,0 -3.936,1.762 -3.936,3.936 -3.936,6.11 -2.174,7.872 0,7.872 2.174,7.872 3.936,6.11 3.936,3.936 3.936,1.762 2.174,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,256.01764,689.36162)"
                id="g928"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -2.74,0 -4.961,2.221 -4.961,4.961 0,2.74 2.221,4.961 4.961,4.961 2.74,0 4.961,-2.221 4.961,-4.961 C 4.961,2.221 2.74,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,247.40442,701.08064)"
                id="g932"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -3.064,0 -5.549,2.484 -5.549,5.549 0,3.064 2.485,5.548 5.549,5.548 3.064,0 5.549,-2.484 5.549,-5.548 C 5.549,2.484 3.064,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,239.88173,713.94453)"
                id="g936"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -3.175,0 -5.75,2.574 -5.75,5.75 0,3.175 2.575,5.749 5.75,5.749 3.175,0 5.75,-2.574 5.75,-5.749 C 5.75,2.574 3.175,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,233.41937,727.8083)"
                id="g940"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -3.069,0 -5.557,2.488 -5.557,5.557 0,3.069 2.488,5.557 5.557,5.557 3.069,0 5.557,-2.488 5.557,-5.557 C 5.557,2.488 3.069,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,228.15829,742.60791)"
                id="g944"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -2.748,0 -4.976,2.228 -4.976,4.976 0,2.748 2.228,4.976 4.976,4.976 2.748,0 4.976,-2.228 4.976,-4.976 C 4.976,2.228 2.748,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,224.46459,758.39696)"
                id="g948"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -2.182,0 -3.951,1.769 -3.951,3.951 0,2.183 1.769,3.952 3.951,3.952 2.182,0 3.951,-1.769 3.951,-3.952 C 3.951,1.769 2.182,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,223.40381,775.20439)"
                id="g952"
              >
                <path
                  id="circle1"
                  d="m 0,0 c -1.311,0 -2.374,1.063 -2.374,2.374 0,1.311 1.063,2.374 2.374,2.374 1.311,0 2.374,-1.063 2.374,-2.374 C 2.374,1.063 1.311,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,280.60436,688.02133)"
                id="g956"
              >
                <path
                  id="circle3"
                  d="m 0,0 c -1.553,0 -2.812,1.259 -2.812,2.812 0,1.553 1.259,2.812 2.812,2.812 1.553,0 2.812,-1.259 2.812,-2.812 C 2.812,1.259 1.553,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,269.49099,696.5621)"
                id="g960"
              >
                <path
                  id="circle3"
                  d="m 0,0 c -2.489,0 -4.507,2.018 -4.507,4.507 0,2.489 2.018,4.506 4.507,4.506 2.489,0 4.507,-2.017 4.507,-4.506 C 4.507,2.018 2.489,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,260.29654,707.71611)"
                id="g964"
              >
                <path
                  id="circle3"
                  d="m 0,0 c -3.006,0 -5.442,2.436 -5.442,5.442 0,3.006 2.436,5.442 5.442,5.442 3.006,0 5.442,-2.436 5.442,-5.442 C 5.442,2.436 3.006,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,252.54021,720.54742)"
                id="g968"
              >
                <path
                  id="circle3"
                  d="m 0,0 c -3.175,0 -5.75,2.574 -5.75,5.75 0,3.175 2.575,5.749 5.75,5.749 3.175,0 5.75,-2.574 5.75,-5.749 C 5.75,2.574 3.175,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,246.13543,734.76999)"
                id="g972"
              >
                <path
                  id="circle3"
                  d="m 0,0 c -3.013,0 -5.455,2.442 -5.455,5.455 0,3.013 2.442,5.455 5.455,5.455 3.013,0 5.455,-2.442 5.455,-5.455 C 5.455,2.442 3.013,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,241.34233,750.35125)"
                id="g976"
              >
                <path
                  id="circle3"
                  d="M 0,0 C -2.498,0 -4.522,2.025 -4.522,4.522 -4.522,7.02 -2.498,9.045 0,9.045 2.498,9.045 4.522,7.02 4.522,4.522 4.522,2.025 2.498,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,239.0822,767.37828)"
                id="g980"
              >
                <path
                  id="circle3"
                  d="m 0,0 c -1.561,0 -2.827,1.266 -2.827,2.827 0,1.561 1.266,2.826 2.827,2.826 1.561,0 2.827,-1.265 2.827,-2.826 C 2.827,1.266 1.561,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,278.57548,707.96466)"
                id="g984"
              >
                <path
                  id="circle3"
                  d="M 0,0 C -2.174,0 -3.936,1.762 -3.936,3.936 -3.936,6.11 -2.174,7.872 0,7.872 2.174,7.872 3.936,6.11 3.936,3.936 3.936,1.762 2.174,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,268.61342,718.91577)"
                id="g988"
              >
                <path
                  id="circle3"
                  d="m 0,0 c -3.064,0 -5.549,2.484 -5.549,5.549 0,3.064 2.485,5.548 5.549,5.548 3.064,0 5.549,-2.484 5.549,-5.548 C 5.549,2.484 3.064,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,261.09187,733.28346)"
                id="g992"
              >
                <path
                  id="circle3"
                  d="m 0,0 c -3.069,0 -5.557,2.488 -5.557,5.557 0,3.069 2.488,5.557 5.557,5.557 3.069,0 5.557,-2.488 5.557,-5.557 C 5.557,2.488 3.069,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,256.27139,750.58107)"
                id="g996"
              >
                <path
                  id="circle3"
                  d="m 0,0 c -2.182,0 -3.951,1.769 -3.951,3.951 0,2.183 1.769,3.952 3.951,3.952 2.182,0 3.951,-1.769 3.951,-3.952 C 3.951,1.769 2.182,0 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,179.62651,595.49426)"
                id="g1000"
              >
                <path
                  id="circle2"
                  d="M 0,0 15.066,8.774 30.539,4.866 C 20.55,1.288 10.204,-0.276 0,0 m -60.59,27.888 15.168,-3.832 -2.375,-7.748 c -4.608,3.373 -8.897,7.249 -12.793,11.58 m -18.531,33.694 14.502,-4.484 -3.194,-19.965 c -1.631,2.423 -3.156,4.949 -4.556,7.584 -2.886,5.431 -5.124,11.084 -6.752,16.865 m 0.582,47.414 c 2.024,6.613 4.808,12.857 8.26,18.649 l 12.604,-27.154 -2.887,-18.039 -19.904,-15.417 c -2.9,13.773 -2.306,28.129 1.927,41.961 m 28.935,41.946 -5.774,-36.092 -13.102,15.657 c 5.09,7.805 11.452,14.695 18.876,20.435 m 7.336,-54.32 -8.68,-6.724 -5.026,10.831 1.648,10.302 z m 13.969,-16.691 -7.168,-23.385 -14.771,31.825 9.026,6.992 z m 10.219,33.348 -9.645,-31.473 -12.187,14.563 z m 18.393,-67.538 -7.318,-4.739 -24.808,7.671 -2.618,5.642 7.39,24.114 z M 8.218,36.295 -4.959,40.37 1.376,44.472 Z M -34.437,21.28 -19.114,17.409 -11.545,1.101 c -11.945,1.979 -23.402,6.498 -33.514,13.3 z m -9.39,2.373 7.215,-1.823 -9.699,-6.281 z m 23.823,-4.324 -12.55,3.17 8.518,5.516 z m -10.876,27.336 22.078,-6.826 -14.54,-9.415 z m -4.904,3.235 0.633,2.064 1.223,-2.637 z m 2.788,-2.582 8.261,-17.798 -9.994,-6.472 -8.616,2.178 7.08,23.103 z m -18.574,40.021 15.383,-33.144 -1.167,-3.808 -25.417,7.858 3.728,23.306 z m -5.642,16.055 -11.552,24.891 13.042,-15.583 z m 0.774,-5.568 4.158,-8.959 -6.382,-4.945 z m -23.633,-32.565 19.129,14.818 -3.415,-21.343 -15.28,4.725 c -0.154,0.598 -0.294,1.199 -0.434,1.8 m 13.614,-30.048 3.423,21.394 25.199,-7.791 -7.106,-23.187 -17.538,4.431 c -1.387,1.652 -2.708,3.376 -3.978,5.153 M -9.595,0.805 -17.061,16.891 12.789,9.35 -3.05,0.124 C -5.243,0.263 -7.425,0.497 -9.595,0.805 M 24.877,16.39 14.819,10.531 -17.953,18.81 -22.643,28.917 -6.756,39.205 10.16,33.975 Z M 39.495,24.903 26.316,17.23 13.052,33.081 Z M 33.563,6.01 C 33.451,5.965 33.338,5.927 33.225,5.882 l -16.129,4.075 8.85,5.154 z M 46.169,8.437 C 45.317,10.04 43.327,10.649 41.724,9.798 39.558,8.648 37.36,7.625 35.145,6.681 l -7.758,9.27 14.553,8.476 c 0.281,0.163 0.44,0.478 0.403,0.802 -0.037,0.324 -0.263,0.596 -0.575,0.692 l -30.658,9.481 -8.345,9.97 12.094,7.831 c 0.382,0.247 0.489,0.756 0.244,1.136 -0.248,0.384 -0.759,0.486 -1.137,0.244 l -12.263,-7.942 -28.17,33.663 10.717,34.97 c 0.105,0.342 -0.024,0.713 -0.319,0.916 -0.293,0.204 -0.686,0.193 -0.97,-0.025 l -23.928,-18.535 -13.014,15.552 6.272,39.202 c 3.238,2.36 6.659,4.513 10.26,6.427 1.603,0.851 2.212,2.841 1.36,4.444 -0.852,1.602 -2.841,2.214 -4.445,1.36 -21.452,-11.397 -37.181,-30.468 -44.29,-53.695 -7.109,-23.228 -4.747,-47.835 6.651,-69.287 16.324,-30.725 47.878,-48.259 80.462,-48.259 14.378,0 28.96,3.416 42.519,10.618 1.603,0.852 2.211,2.842 1.361,4.445"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,58.40286,507.34118)"
                id="g1004"
              >
                <path
                  id="circle2"
                  d="M 0,0 0.134,-0.126 C -0.252,-0.703 -0.524,-1.176 -0.681,-1.545 -0.837,-1.915 -1,-2.449 -1.167,-3.149 l -0.135,-0.546 c -0.761,-0.201 -1.265,-0.353 -1.511,-0.453 l -0.177,0.217 c 0.61,1.322 1.422,2.571 2.435,3.746 z m -3.267,0 0.134,-0.126 c -0.386,-0.577 -0.659,-1.054 -0.819,-1.432 -0.159,-0.378 -0.32,-0.909 -0.483,-1.591 l -0.134,-0.546 c -0.778,-0.207 -1.282,-0.359 -1.512,-0.453 l -0.176,0.217 c 0.611,1.311 1.422,2.559 2.436,3.746 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,61.455484,499.80779)"
                id="g1008"
              >
                <path
                  id="circle2"
                  d="M 0,0 H 3.695 L 3.057,4.88 Z m -4.871,-5.417 -0.059,0.067 0.059,0.37 0.076,0.059 0.487,0.075 c 0.14,0.023 0.235,0.048 0.285,0.075 0.051,0.029 0.104,0.077 0.16,0.144 0.056,0.066 0.182,0.246 0.378,0.537 0.195,0.291 0.453,0.692 0.773,1.201 l 0.184,0.269 5.812,9.196 H 4.073 L 5.484,-3.569 c 0.078,-0.566 0.148,-0.908 0.21,-1.025 0.061,-0.117 0.154,-0.19 0.277,-0.218 0.123,-0.028 0.443,-0.065 0.958,-0.109 L 6.979,-4.988 6.912,-5.35 6.836,-5.417 c -0.784,0.045 -1.459,0.067 -2.024,0.067 -0.38,0 -1.05,-0.022 -2.007,-0.067 l -0.059,0.067 0.059,0.362 0.075,0.067 c 0.695,0.027 1.091,0.069 1.189,0.126 0.098,0.056 0.147,0.176 0.147,0.36 0,0.045 -0.039,0.477 -0.118,1.294 L 3.771,-0.655 H -0.42 L -1.604,-2.62 c -0.112,-0.185 -0.29,-0.498 -0.533,-0.941 -0.244,-0.442 -0.384,-0.71 -0.42,-0.802 -0.037,-0.092 -0.055,-0.166 -0.055,-0.222 0,-0.096 0.055,-0.167 0.164,-0.215 0.109,-0.047 0.519,-0.085 1.23,-0.113 l 0.051,-0.067 -0.059,-0.37 -0.076,-0.067 c -0.649,0.045 -1.26,0.067 -1.83,0.067 -0.471,0 -1.05,-0.022 -1.739,-0.067"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,81.974117,501.61963)"
                id="g1012"
              >
                <path
                  id="circle2"
                  d="M 0,0 C -0.526,0.274 -1.069,0.411 -1.629,0.411 -1.977,0.411 -2.258,0.374 -2.473,0.298 -2.689,0.223 -2.851,0.129 -2.96,0.017 -3.07,-0.095 -3.212,-0.337 -3.389,-0.71 -3.565,-1.082 -3.737,-1.538 -3.905,-2.078 -4.073,-2.619 -4.203,-3.15 -4.296,-3.674 -4.388,-4.198 -4.434,-4.703 -4.434,-5.19 c 0,-0.302 0.03,-0.512 0.092,-0.63 0.062,-0.117 0.157,-0.176 0.286,-0.176 0.212,0 0.514,0.123 0.907,0.369 0.593,0.381 1.125,0.891 1.595,1.528 0.471,0.639 0.824,1.32 1.058,2.041 C -0.389,-1.728 -0.224,-1.041 0,0 M 2.032,5.408 2.242,5.249 C 1.979,4.141 1.68,2.782 1.344,1.176 L 0.353,-3.561 C 0.196,-4.367 0.098,-4.938 0.059,-5.274 0.047,-5.381 0.042,-5.489 0.042,-5.602 c 0,-0.268 0.078,-0.403 0.235,-0.403 0.213,0 0.658,0.269 1.335,0.807 L 1.705,-5.224 1.789,-5.417 1.764,-5.526 C 1.243,-5.979 0.73,-6.367 0.227,-6.689 c -0.504,-0.322 -0.863,-0.483 -1.075,-0.483 -0.118,0 -0.214,0.063 -0.29,0.189 -0.075,0.126 -0.113,0.315 -0.113,0.567 0,0.207 0.04,0.52 0.122,0.937 0.081,0.417 0.231,1.082 0.449,1.994 l -0.042,0.008 c -0.605,-1.019 -1.326,-1.889 -2.163,-2.612 -0.837,-0.722 -1.49,-1.083 -1.961,-1.083 -0.168,0 -0.311,0.059 -0.428,0.176 -0.118,0.118 -0.213,0.333 -0.286,0.647 -0.072,0.314 -0.109,0.644 -0.109,0.991 0,0.476 0.079,1.084 0.235,1.823 0.157,0.738 0.356,1.378 0.597,1.919 0.24,0.54 0.48,0.947 0.718,1.221 0.238,0.275 0.555,0.546 0.953,0.815 0.397,0.268 0.74,0.462 1.029,0.579 0.288,0.118 0.583,0.177 0.886,0.177 0.324,0 0.794,-0.071 1.411,-0.21 L 0.596,3.511 C 0.641,3.724 0.664,3.902 0.664,4.048 0.664,4.171 0.62,4.258 0.533,4.309 0.446,4.358 0.291,4.384 0.067,4.384 l -0.705,0.009 -0.068,0.067 0.026,0.21 0.067,0.075 c 1.047,0.168 1.928,0.389 2.645,0.663"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,88.126497,506.15918)"
                id="g1016"
              >
                <path
                  id="circle2"
                  d="m 0,0 c 0,0.296 0.094,0.558 0.281,0.785 0.188,0.227 0.416,0.34 0.685,0.34 0.19,0 0.344,-0.059 0.462,-0.177 0.117,-0.117 0.176,-0.285 0.176,-0.504 0,-0.301 -0.086,-0.572 -0.26,-0.81 -0.174,-0.238 -0.392,-0.357 -0.655,-0.357 -0.196,0 -0.36,0.068 -0.492,0.202 C 0.066,-0.387 0,-0.213 0,0 m -2.192,-4.687 -0.084,0.194 0.026,0.108 c 0.761,0.549 1.347,0.934 1.759,1.156 0.411,0.22 0.735,0.332 0.97,0.332 0.229,0 0.344,-0.166 0.344,-0.497 0,-0.151 -0.029,-0.365 -0.088,-0.642 -0.059,-0.276 -0.2,-0.835 -0.424,-1.675 -0.61,-2.263 -0.915,-3.601 -0.915,-4.015 0,-0.223 0.078,-0.336 0.234,-0.336 0.241,0 0.678,0.239 1.311,0.714 L 1.025,-9.373 1.117,-9.591 1.1,-9.692 c -0.392,-0.302 -0.795,-0.593 -1.209,-0.873 -0.414,-0.281 -0.71,-0.458 -0.886,-0.534 -0.176,-0.075 -0.323,-0.113 -0.441,-0.113 -0.168,0 -0.299,0.072 -0.395,0.218 -0.095,0.145 -0.143,0.316 -0.143,0.513 0,0.252 0.036,0.522 0.105,0.81 0.071,0.288 0.156,0.608 0.257,0.962 0.363,1.299 0.622,2.312 0.777,3.04 0.153,0.728 0.231,1.173 0.231,1.335 0,0.19 -0.065,0.285 -0.194,0.285 -0.084,0 -0.165,-0.02 -0.243,-0.062 -0.079,-0.042 -0.432,-0.245 -1.059,-0.61 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,97.933287,502.02987)"
                id="g1020"
              >
                <path
                  id="circle2"
                  d="M 0,0 C 0.28,1.483 0.47,2.365 0.571,2.646 0.672,2.925 1.11,3.399 1.885,4.068 2.661,4.737 3.339,5.072 3.922,5.072 4.28,5.072 4.647,4.997 5.022,4.846 4.804,4.264 4.647,3.799 4.552,3.451 L 4.359,3.393 C 4.095,3.813 3.692,4.022 3.149,4.022 2.886,4.022 2.654,3.954 2.452,3.816 2.25,3.68 2.085,3.457 1.957,3.149 1.828,2.841 1.596,1.791 1.26,0 h 0.966 c 0.38,0 0.657,0.02 0.831,0.059 L 3.132,-0.034 C 3.093,-0.146 3.006,-0.412 2.872,-0.832 L 2.796,-0.891 c -0.257,0.012 -0.515,0.017 -0.772,0.017 -0.185,0 -0.493,-0.005 -0.924,-0.017 l -1.117,-5.097 c -0.212,-0.963 -0.399,-1.71 -0.558,-2.242 -0.16,-0.533 -0.384,-1.064 -0.672,-1.596 -0.289,-0.532 -0.612,-0.969 -0.97,-1.311 -0.359,-0.341 -0.695,-0.592 -1.008,-0.756 -0.314,-0.162 -0.616,-0.243 -0.907,-0.243 -0.179,0 -0.378,0.054 -0.596,0.159 0.185,0.549 0.316,1.008 0.395,1.378 l 0.209,0.05 c 0.235,-0.313 0.527,-0.47 0.874,-0.47 0.537,0 0.957,0.342 1.26,1.025 0.302,0.683 0.688,2.393 1.158,5.132 l 0.681,3.971 h -3.334 l -1.218,-5.618 c -0.443,-2.044 -1.053,-3.492 -1.831,-4.345 -0.778,-0.855 -1.503,-1.282 -2.175,-1.282 -0.19,0 -0.389,0.054 -0.596,0.159 0.184,0.549 0.316,1.008 0.394,1.378 l 0.21,0.05 c 0.236,-0.313 0.524,-0.47 0.866,-0.47 0.554,0 0.986,0.352 1.297,1.054 0.31,0.703 0.738,2.687 1.281,5.95 l 0.52,3.124 -0.672,0.009 c -0.285,0 -0.495,-0.006 -0.63,-0.016 l -0.066,0.066 0.058,0.261 0.068,0.067 c 0.375,0.123 0.839,0.297 1.394,0.521 l 0.394,1.931 c 0.095,0.459 0.224,0.801 0.386,1.025 0.163,0.223 0.514,0.558 1.055,1.004 0.54,0.445 0.957,0.739 1.251,0.881 0.294,0.143 0.572,0.214 0.835,0.214 0.37,0 0.74,-0.075 1.109,-0.226 C 0.227,4.264 0.067,3.799 -0.034,3.451 L -0.218,3.393 C -0.493,3.813 -0.896,4.022 -1.428,4.022 -1.719,4.022 -2.014,3.9 -2.314,3.657 -2.613,3.414 -2.954,2.194 -3.334,0 Z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,102.92267,498.26312)"
                id="g1024"
              >
                <path
                  id="circle2"
                  d="M 0,0 C 0.588,0.106 1.146,0.272 1.675,0.5 2.205,0.727 2.61,1.028 2.893,1.406 3.176,1.784 3.317,2.169 3.317,2.562 3.317,2.863 3.242,3.088 3.09,3.233 2.939,3.379 2.757,3.451 2.544,3.451 2.31,3.451 2.034,3.385 1.717,3.25 1.401,3.115 1.121,2.869 0.877,2.511 0.634,2.152 0.341,1.315 0,0 M 3.863,-2.192 3.956,-2.402 3.938,-2.511 C 2.562,-3.676 1.394,-4.258 0.437,-4.258 c -0.314,0 -0.633,0.085 -0.958,0.256 -0.325,0.171 -0.567,0.416 -0.726,0.735 -0.16,0.319 -0.24,0.728 -0.24,1.226 0,0.7 0.116,1.446 0.349,2.238 0.232,0.792 0.465,1.377 0.697,1.755 C -0.209,2.33 0.14,2.686 0.604,3.02 1.069,3.353 1.51,3.621 1.927,3.825 2.344,4.029 2.749,4.132 3.141,4.132 3.566,4.132 3.914,4.02 4.182,3.796 4.451,3.572 4.585,3.261 4.585,2.863 4.585,2.41 4.457,1.991 4.199,1.608 3.941,1.225 3.471,0.862 2.788,0.521 2.105,0.179 1.288,-0.101 0.336,-0.319 l -0.395,-0.092 c -0.112,-0.538 -0.168,-0.986 -0.168,-1.344 0,-0.504 0.112,-0.904 0.336,-1.201 0.224,-0.297 0.537,-0.445 0.941,-0.445 0.756,0 1.662,0.414 2.721,1.243 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,109.61913,493.44744)"
                id="g1028"
              >
                <path
                  id="circle2"
                  d="M 0,0 -0.151,0.117 C 0.241,1.399 0.568,2.739 0.832,4.136 1.094,5.533 1.226,6.431 1.226,6.828 1.226,7.08 1.159,7.206 1.024,7.206 0.856,7.206 0.392,6.954 -0.37,6.45 l -0.1,0.025 -0.084,0.185 0.025,0.126 c 0.498,0.398 1.023,0.761 1.574,1.092 0.552,0.33 0.956,0.495 1.214,0.495 0.224,0 0.336,-0.14 0.336,-0.42 0,-0.325 -0.204,-1.408 -0.613,-3.25 0.52,0.912 1.03,1.684 1.528,2.314 C 4.009,7.646 4.368,8.033 4.589,8.176 4.811,8.318 5.03,8.39 5.249,8.39 5.35,8.39 5.45,8.367 5.551,8.322 L 5.585,8.23 C 5.501,7.922 5.405,7.326 5.299,6.441 L 5.064,6.391 C 4.901,6.615 4.714,6.727 4.501,6.727 4.345,6.727 4.156,6.662 3.935,6.534 3.713,6.405 3.44,6.145 3.116,5.753 2.791,5.361 2.509,4.917 2.271,4.422 2.034,3.926 1.842,3.385 1.696,2.797 1.551,2.209 1.366,1.374 1.142,0.294 0.577,0.165 0.196,0.067 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,118.12809,498.26312)"
                id="g1032"
              >
                <path
                  id="circle2"
                  d="M 0,0 C 0.588,0.106 1.146,0.272 1.675,0.5 2.205,0.727 2.61,1.028 2.893,1.406 3.176,1.784 3.317,2.169 3.317,2.562 3.317,2.863 3.242,3.088 3.09,3.233 2.939,3.379 2.757,3.451 2.544,3.451 2.31,3.451 2.034,3.385 1.717,3.25 1.401,3.115 1.121,2.869 0.877,2.511 0.634,2.152 0.341,1.315 0,0 M 3.863,-2.192 3.956,-2.402 3.938,-2.511 C 2.562,-3.676 1.394,-4.258 0.437,-4.258 c -0.314,0 -0.633,0.085 -0.958,0.256 -0.325,0.171 -0.567,0.416 -0.726,0.735 -0.16,0.319 -0.24,0.728 -0.24,1.226 0,0.7 0.116,1.446 0.349,2.238 0.232,0.792 0.465,1.377 0.697,1.755 C -0.209,2.33 0.14,2.686 0.604,3.02 1.069,3.353 1.51,3.621 1.927,3.825 2.344,4.029 2.749,4.132 3.141,4.132 3.566,4.132 3.914,4.02 4.182,3.796 4.451,3.572 4.585,3.261 4.585,2.863 4.585,2.41 4.457,1.991 4.199,1.608 3.941,1.225 3.471,0.862 2.788,0.521 2.105,0.179 1.288,-0.101 0.336,-0.319 l -0.395,-0.092 c -0.112,-0.538 -0.168,-0.986 -0.168,-1.344 0,-0.504 0.112,-0.904 0.336,-1.201 0.224,-0.297 0.537,-0.445 0.941,-0.445 0.756,0 1.662,0.414 2.721,1.243 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,124.81512,493.49513)"
                id="g1036"
              >
                <path
                  id="circle2"
                  d="m 0,0 -0.109,0.143 c 0.363,1.114 0.687,2.399 0.97,3.855 0.282,1.455 0.424,2.379 0.424,2.771 0,0.218 -0.076,0.328 -0.227,0.328 -0.207,0 -0.638,-0.222 -1.293,-0.664 l -0.101,0.025 -0.076,0.185 0.025,0.126 c 0.224,0.168 0.492,0.358 0.803,0.571 0.31,0.213 0.617,0.402 0.919,0.567 0.302,0.165 0.511,0.266 0.626,0.302 0.115,0.037 0.217,0.055 0.306,0.055 0.157,0 0.265,-0.055 0.324,-0.163 C 2.649,7.991 2.679,7.878 2.679,7.76 2.679,7.508 2.586,7.01 2.402,6.265 2.346,6.058 2.194,5.445 1.948,4.426 L 2.007,4.409 C 2.421,5.087 2.931,5.736 3.536,6.357 4.14,6.979 4.764,7.452 5.408,7.776 6.052,8.102 6.525,8.264 6.828,8.264 6.996,8.264 7.122,8.212 7.206,8.108 7.29,8.005 7.332,7.872 7.332,7.71 7.332,7.323 7.138,6.383 6.752,4.888 6.231,2.895 5.971,1.722 5.971,1.369 c 0,-0.207 0.075,-0.31 0.227,-0.31 0.184,0 0.655,0.268 1.41,0.805 L 7.701,1.839 7.793,1.621 7.768,1.521 C 7.421,1.24 7.023,0.953 6.576,0.659 6.127,0.365 5.803,0.174 5.602,0.084 5.4,-0.006 5.232,-0.051 5.098,-0.051 4.924,-0.051 4.796,0.01 4.715,0.13 4.634,0.251 4.594,0.4 4.594,0.579 c 0,0.196 0.044,0.503 0.134,0.92 0.089,0.417 0.277,1.183 0.563,2.297 0.408,1.573 0.613,2.539 0.613,2.897 0,0.297 -0.107,0.446 -0.32,0.446 C 5.434,7.139 5.257,7.091 5.056,6.996 4.697,6.828 4.311,6.555 3.896,6.177 3.482,5.799 3.103,5.356 2.759,4.85 2.414,4.343 2.146,3.839 1.952,3.338 1.759,2.837 1.59,2.271 1.444,1.638 1.422,1.56 1.335,1.103 1.184,0.269 0.798,0.207 0.403,0.117 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,139.78156,495.85028)"
                id="g1040"
              >
                <path
                  id="circle2"
                  d="M 0,0 0.093,-0.193 0.067,-0.294 c -0.218,-0.19 -0.597,-0.48 -1.138,-0.869 -0.54,-0.389 -0.929,-0.649 -1.167,-0.781 -0.238,-0.131 -0.444,-0.198 -0.617,-0.198 -0.163,0 -0.293,0.077 -0.391,0.227 -0.098,0.151 -0.147,0.367 -0.147,0.647 0,0.331 0.096,0.921 0.286,1.772 0.218,0.985 0.498,2.388 0.84,4.208 l -1.369,-0.034 -0.059,0.067 0.025,0.143 0.067,0.067 c 0.6,0.213 1.081,0.417 1.445,0.613 0.106,0.493 0.252,1.458 0.436,2.898 0.599,0.252 1.039,0.453 1.319,0.604 L -0.201,8.919 -0.529,7.634 C -0.568,7.472 -0.716,6.749 -0.974,5.468 -0.722,5.45 -0.518,5.442 -0.361,5.442 c 0.554,0 0.946,0.039 1.176,0.118 L 0.899,5.492 0.706,4.67 c -0.207,0 -0.818,0.014 -1.831,0.042 -0.622,-2.984 -0.933,-4.742 -0.933,-5.274 0,-0.258 0.107,-0.387 0.32,-0.387 0.106,0 0.247,0.047 0.424,0.138 0.176,0.093 0.483,0.299 0.919,0.618 l 0.294,0.227 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,146.32604,500.3988)"
                id="g1044"
              >
                <path
                  id="circle2"
                  d="M 0,0 -0.05,0.067 0.63,1.999 C 0.871,2.083 1.108,2.125 1.344,2.125 1.54,2.125 1.895,2.1 2.41,2.05 c 0.454,-0.045 0.787,-0.068 1,-0.068 0.336,0 0.641,0.047 0.915,0.143 L 4.476,1.89 C 2.948,0.015 2.184,-1.78 2.184,-3.493 c 0,-1.176 0.321,-1.764 0.965,-1.764 0.471,0 1.029,0.514 1.676,1.541 0.647,1.028 1.188,2.876 1.625,5.547 0.42,0.062 0.842,0.174 1.268,0.336 L 7.835,2.066 C 7.007,-0.61 6.593,-2.542 6.593,-3.729 c 0,-0.442 0.095,-0.804 0.285,-1.087 0.19,-0.283 0.456,-0.424 0.798,-0.424 0.75,0 1.418,0.568 2.003,1.705 0.585,1.137 0.878,2.253 0.878,3.35 0,0.824 -0.281,1.235 -0.84,1.235 C 9.577,1.05 9.431,1.014 9.28,0.94 L 9.188,0.958 9.053,1.108 v 0.093 c 0.336,0.314 0.63,0.613 0.882,0.899 0.163,0.055 0.322,0.084 0.479,0.084 0.812,0 1.218,-0.563 1.218,-1.688 0,-0.907 -0.262,-1.901 -0.786,-2.981 C 10.323,-3.566 9.69,-4.449 8.948,-5.136 8.207,-5.821 7.528,-6.164 6.912,-6.164 c -0.448,0 -0.798,0.159 -1.05,0.478 -0.252,0.32 -0.378,0.72 -0.378,1.202 0,0.498 0.056,1.024 0.168,1.579 L 5.089,-3.922 C 4.708,-4.61 4.282,-5.156 3.809,-5.56 3.335,-5.963 2.892,-6.164 2.478,-6.164 c -0.465,0 -0.837,0.206 -1.118,0.617 -0.279,0.411 -0.42,0.947 -0.42,1.609 0,0.761 0.176,1.529 0.525,2.305 0.35,0.776 1.029,1.717 2.037,2.825 C 3.379,1.147 2.973,1.126 2.284,1.126 L 1.923,1.143 C 1.554,1.143 1.204,1.111 0.874,1.05 0.778,0.91 0.591,0.577 0.311,0.051 L 0.227,0 Z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,165.92906,501.67732)"
                id="g1048"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -0.426,0.195 -0.885,0.294 -1.377,0.294 -0.409,0 -0.773,-0.076 -1.092,-0.228 -0.118,-0.088 -0.238,-0.247 -0.361,-0.473 -0.124,-0.228 -0.297,-0.651 -0.521,-1.269 -0.224,-0.619 -0.406,-1.279 -0.546,-1.982 -0.14,-0.702 -0.21,-1.261 -0.21,-1.675 0,-0.309 0.027,-0.507 0.08,-0.597 0.053,-0.09 0.133,-0.133 0.239,-0.133 0.202,0 0.597,0.271 1.184,0.814 0.588,0.543 1.085,1.173 1.491,1.89 0.406,0.716 0.74,1.673 1.004,2.872 z M 1.419,-5.35 1.478,-5.577 1.444,-5.678 c -1.175,-1.013 -1.976,-1.519 -2.402,-1.519 -0.279,0 -0.419,0.178 -0.419,0.537 0,0.174 0.018,0.393 0.054,0.659 0.036,0.266 0.091,0.559 0.164,0.878 l 0.21,0.898 0.126,0.496 -0.051,0.025 c -0.834,-1.187 -1.613,-2.077 -2.338,-2.671 -0.726,-0.593 -1.234,-0.89 -1.525,-0.89 -0.391,0 -0.588,0.479 -0.588,1.436 0,0.6 0.092,1.279 0.273,2.041 0.182,0.762 0.405,1.467 0.668,2.116 0.263,0.65 0.475,1.076 0.634,1.281 0.16,0.204 0.426,0.438 0.798,0.702 0.372,0.262 0.721,0.464 1.046,0.604 0.324,0.14 0.685,0.21 1.083,0.21 0.487,0 1.005,-0.101 1.553,-0.303 L 1.268,1.142 1.453,0.99 C 1.436,0.906 1.318,0.486 1.1,-0.27 L 0.714,-1.697 0.504,-2.528 c -0.151,-0.594 -0.291,-1.214 -0.42,-1.861 -0.129,-0.646 -0.193,-1.087 -0.193,-1.322 0,-0.225 0.075,-0.336 0.227,-0.336 0.095,0 0.221,0.042 0.378,0.126 0.156,0.084 0.439,0.282 0.848,0.596 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,168.08492,490.12873)"
                id="g1052"
              >
                <path
                  id="circle2"
                  d="M 0,0 0.831,0.562 1.008,0.504 C 0.996,0.415 0.991,0.336 0.991,0.269 c 0,-0.403 0.117,-0.706 0.353,-0.912 0.235,-0.204 0.487,-0.306 0.756,-0.306 0.213,0 0.429,0.054 0.65,0.164 0.222,0.109 0.438,0.29 0.647,0.542 0.21,0.252 0.447,0.675 0.709,1.267 C 4.37,1.618 4.609,2.258 4.825,2.944 5.04,3.63 5.249,4.345 5.45,5.09 L 5.736,6.14 C 5.355,5.557 5.006,5.09 4.687,4.737 4.367,4.384 4.054,4.048 3.746,3.729 3.438,3.41 3.183,3.188 2.981,3.065 2.78,2.942 2.601,2.881 2.444,2.881 2.209,2.881 2.024,3.025 1.89,3.313 1.755,3.602 1.688,3.959 1.688,4.384 c 0,0.219 0.04,0.667 0.118,1.344 0.134,1.226 0.201,2.29 0.201,3.191 0,0.465 -0.024,0.769 -0.071,0.911 C 1.889,9.974 1.806,10.045 1.688,10.045 1.559,10.045 1.396,9.98 1.201,9.852 1.005,9.723 0.758,9.543 0.462,9.313 L 0.353,9.348 0.26,9.549 0.285,9.675 c 1.249,1.053 2.072,1.579 2.47,1.579 0.168,0 0.301,-0.073 0.398,-0.219 C 3.252,10.89 3.301,10.615 3.301,10.213 3.301,9.832 3.272,9.333 3.217,8.718 3.043,6.814 2.956,5.543 2.956,4.905 2.956,4.681 2.98,4.51 3.027,4.393 3.075,4.275 3.16,4.216 3.284,4.216 c 0.084,0 0.195,0.034 0.331,0.101 0.138,0.067 0.358,0.249 0.659,0.546 0.303,0.296 0.606,0.67 0.908,1.121 0.302,0.451 0.572,0.948 0.81,1.491 0.238,0.543 0.424,1.061 0.559,1.553 0.135,0.493 0.297,1.134 0.487,1.923 0.381,0.057 0.803,0.163 1.268,0.32 L 8.491,11.103 C 8.21,10.543 7.696,8.983 6.945,6.425 6.564,5.109 6.247,4.072 5.992,3.313 5.737,2.555 5.437,1.863 5.09,1.239 4.742,0.615 4.339,0.073 3.88,-0.386 3.421,-0.845 2.988,-1.168 2.582,-1.356 2.177,-1.544 1.789,-1.638 1.419,-1.638 c -0.398,0 -0.74,0.125 -1.029,0.374 -0.288,0.249 -0.432,0.576 -0.432,0.979 0,0.084 0.014,0.179 0.042,0.285"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,188.08003,495.85028)"
                id="g1056"
              >
                <path
                  id="circle2"
                  d="M 0,0 0.092,-0.193 0.067,-0.294 c -0.218,-0.19 -0.598,-0.48 -1.138,-0.869 -0.54,-0.389 -0.93,-0.649 -1.167,-0.781 -0.239,-0.131 -0.445,-0.198 -0.617,-0.198 -0.164,0 -0.293,0.077 -0.391,0.227 -0.099,0.151 -0.148,0.367 -0.148,0.647 0,0.331 0.096,0.921 0.287,1.772 0.217,0.985 0.498,2.388 0.839,4.208 l -1.369,-0.034 -0.058,0.067 0.025,0.143 0.066,0.067 c 0.6,0.213 1.082,0.417 1.446,0.613 0.105,0.493 0.252,1.458 0.436,2.898 0.599,0.252 1.038,0.453 1.319,0.604 L -0.202,8.919 -0.529,7.634 C -0.568,7.472 -0.717,6.749 -0.975,5.468 -0.723,5.45 -0.519,5.442 -0.361,5.442 c 0.553,0 0.946,0.039 1.175,0.118 L 0.898,5.492 0.705,4.67 c -0.207,0 -0.817,0.014 -1.831,0.042 -0.621,-2.984 -0.932,-4.742 -0.932,-5.274 0,-0.258 0.107,-0.387 0.32,-0.387 0.105,0 0.247,0.047 0.424,0.138 0.175,0.093 0.482,0.299 0.919,0.618 l 0.294,0.227 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,191.25578,496.52781)"
                id="g1060"
              >
                <path
                  id="circle2"
                  d="m 0,0 c 0,-0.481 0.048,-0.864 0.144,-1.146 0.094,-0.284 0.262,-0.51 0.503,-0.681 0.241,-0.171 0.538,-0.256 0.89,-0.256 0.37,0 0.694,0.098 0.975,0.294 0.279,0.196 0.546,0.56 0.798,1.092 0.252,0.532 0.434,1.127 0.549,1.784 0.115,0.658 0.172,1.265 0.172,1.818 0,0.51 -0.058,0.918 -0.176,1.227 C 3.737,4.439 3.564,4.672 3.334,4.829 3.104,4.985 2.828,5.063 2.503,5.063 1.641,5.063 1.008,4.548 0.605,3.515 0.202,2.481 0,1.31 0,0 m -1.344,-0.118 c 0,1.069 0.183,2.044 0.546,2.923 0.364,0.879 0.92,1.577 1.667,2.095 0.748,0.518 1.478,0.777 2.189,0.777 0.649,0 1.195,-0.198 1.637,-0.592 C 5.138,4.69 5.358,4.014 5.358,3.057 5.358,2.116 5.149,1.164 4.732,0.201 4.315,-0.762 3.743,-1.489 3.016,-1.982 2.287,-2.475 1.573,-2.722 0.874,-2.722 c -0.465,0 -0.871,0.109 -1.218,0.324 -0.347,0.215 -0.6,0.509 -0.76,0.881 -0.16,0.373 -0.24,0.839 -0.24,1.399"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,203.93323,493.54281)"
                id="g1064"
              >
                <path
                  id="circle2"
                  d="M 0,0 -0.126,0.143 0.361,1.89 C 0.529,2.506 0.69,3.179 0.844,3.909 0.998,4.64 1.107,5.242 1.172,5.715 1.236,6.188 1.269,6.509 1.269,6.677 1.269,6.968 1.187,7.113 1.024,7.113 0.946,7.113 0.83,7.074 0.676,6.996 0.522,6.917 0.232,6.741 -0.193,6.467 L -0.294,6.5 -0.378,6.685 -0.353,6.811 c 1.328,0.968 2.207,1.453 2.637,1.453 0.247,0 0.37,-0.14 0.37,-0.42 C 2.654,7.737 2.639,7.582 2.607,7.378 2.577,7.174 2.402,6.324 2.083,4.829 2.855,5.927 3.65,6.771 4.468,7.361 5.285,7.952 5.952,8.247 6.467,8.247 6.741,8.247 6.878,8.121 6.878,7.869 6.878,7.634 6.851,7.356 6.794,7.038 6.738,6.719 6.573,5.974 6.299,4.804 7.1,5.918 7.955,6.771 8.864,7.365 c 0.91,0.594 1.617,0.891 2.121,0.891 0.275,0 0.411,-0.141 0.411,-0.42 0,-0.381 -0.277,-1.599 -0.831,-3.653 C 10.14,2.62 9.927,1.674 9.927,1.344 c 0,-0.23 0.081,-0.345 0.244,-0.345 0.089,0 0.211,0.037 0.365,0.109 0.153,0.074 0.477,0.287 0.97,0.639 L 11.59,1.713 11.683,1.503 11.657,1.395 C 11.405,1.192 11.06,0.942 10.62,0.643 10.181,0.343 9.849,0.145 9.625,0.046 9.4,-0.052 9.216,-0.101 9.07,-0.101 8.908,-0.101 8.779,-0.041 8.684,0.08 8.589,0.2 8.541,0.355 8.541,0.546 c 0,0.162 0.013,0.309 0.038,0.44 0.025,0.132 0.105,0.442 0.239,0.929 0.202,0.717 0.436,1.641 0.702,2.772 0.265,1.13 0.399,1.855 0.399,2.174 0,0.101 -0.028,0.175 -0.084,0.223 C 9.778,7.132 9.717,7.155 9.649,7.155 9.504,7.155 9.265,7.065 8.932,6.887 8.599,6.707 8.214,6.402 7.777,5.971 7.34,5.54 6.983,5.106 6.706,4.67 6.429,4.232 6.195,3.687 6.005,3.032 5.814,2.377 5.613,1.437 5.4,0.21 5.143,0.171 4.754,0.093 4.232,-0.025 l -0.126,0.1 c 0.443,1.591 0.785,2.994 1.026,4.212 0.24,1.218 0.36,2.045 0.36,2.482 C 5.492,7.01 5.411,7.13 5.249,7.13 5.087,7.13 4.846,7.042 4.526,6.865 4.208,6.689 3.817,6.352 3.355,5.854 2.894,5.355 2.521,4.812 2.238,4.225 1.955,3.637 1.725,2.928 1.546,2.1 1.366,1.271 1.237,0.646 1.159,0.227 0.723,0.159 0.336,0.084 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,224.50957,501.67732)"
                id="g1068"
              >
                <path
                  id="circle2"
                  d="m 0,0 c -0.425,0.195 -0.884,0.294 -1.377,0.294 -0.408,0 -0.772,-0.076 -1.092,-0.228 -0.117,-0.088 -0.238,-0.247 -0.361,-0.473 -0.123,-0.228 -0.297,-0.651 -0.521,-1.269 -0.223,-0.619 -0.406,-1.279 -0.545,-1.982 -0.14,-0.702 -0.21,-1.261 -0.21,-1.675 0,-0.309 0.026,-0.507 0.08,-0.597 0.052,-0.09 0.132,-0.133 0.239,-0.133 0.201,0 0.597,0.271 1.184,0.814 0.588,0.543 1.084,1.173 1.491,1.89 0.406,0.716 0.74,1.673 1.004,2.872 z M 1.42,-5.35 1.479,-5.577 1.445,-5.678 c -1.175,-1.013 -1.976,-1.519 -2.402,-1.519 -0.28,0 -0.42,0.178 -0.42,0.537 0,0.174 0.019,0.393 0.055,0.659 0.036,0.266 0.091,0.559 0.164,0.878 l 0.21,0.898 0.126,0.496 -0.051,0.025 c -0.834,-1.187 -1.614,-2.077 -2.339,-2.671 -0.725,-0.593 -1.233,-0.89 -1.524,-0.89 -0.392,0 -0.588,0.479 -0.588,1.436 0,0.6 0.091,1.279 0.273,2.041 0.182,0.762 0.405,1.467 0.667,2.116 0.264,0.65 0.475,1.076 0.635,1.281 0.159,0.204 0.425,0.438 0.798,0.702 0.372,0.262 0.721,0.464 1.045,0.604 0.325,0.14 0.686,0.21 1.084,0.21 0.486,0 1.005,-0.101 1.553,-0.303 L 1.269,1.142 1.453,0.99 C 1.437,0.906 1.319,0.486 1.101,-0.27 L 0.714,-1.697 0.504,-2.528 c -0.15,-0.594 -0.291,-1.214 -0.42,-1.861 -0.128,-0.646 -0.192,-1.087 -0.192,-1.322 0,-0.225 0.075,-0.336 0.226,-0.336 0.095,0 0.221,0.042 0.378,0.126 0.156,0.084 0.44,0.282 0.848,0.596 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,231.13061,507.76039)"
                id="g1072"
              >
                <path
                  id="circle2"
                  d="M 0,0 0.21,-0.159 C 0.014,-0.966 -0.247,-2.145 -0.571,-3.695 l -0.488,-2.318 c -0.201,-0.958 -0.386,-1.766 -0.554,-2.426 0.437,0.627 0.992,1.321 1.667,2.082 0.675,0.761 1.284,1.317 1.827,1.667 0.543,0.35 1.011,0.525 1.402,0.525 0.156,0 0.35,-0.045 0.579,-0.135 L 3.577,-5.476 C 3.331,-5.397 3.096,-5.357 2.872,-5.357 2.569,-5.357 2.27,-5.42 1.973,-5.543 1.677,-5.666 1.37,-5.854 1.054,-6.109 0.737,-6.364 0.392,-6.682 0.017,-7.062 c 0.19,-0.6 0.446,-1.302 0.768,-2.109 0.321,-0.806 0.567,-1.371 0.735,-1.696 0.167,-0.324 0.299,-0.518 0.394,-0.579 0.096,-0.062 0.177,-0.093 0.244,-0.093 0.156,0 0.445,0.129 0.864,0.387 l 0.261,0.159 0.093,-0.026 0.084,-0.201 -0.025,-0.1 c -0.79,-0.583 -1.309,-0.944 -1.558,-1.084 -0.25,-0.14 -0.433,-0.21 -0.551,-0.21 -0.055,0 -0.116,0.018 -0.18,0.054 -0.065,0.038 -0.156,0.141 -0.273,0.311 -0.117,0.171 -0.283,0.506 -0.495,1.004 -0.213,0.498 -0.378,0.905 -0.496,1.222 -0.117,0.316 -0.356,0.981 -0.714,1.995 -0.342,-0.42 -0.56,-0.701 -0.655,-0.844 -0.095,-0.144 -0.175,-0.292 -0.24,-0.445 -0.064,-0.155 -0.135,-0.385 -0.213,-0.694 -0.079,-0.307 -0.152,-0.663 -0.219,-1.066 l -0.201,-1.193 -1.143,-0.302 -0.143,0.109 0.413,1.596 c 0.172,0.678 0.429,1.838 0.767,3.481 0.339,1.643 0.581,2.893 0.727,3.75 l 0.311,1.755 c 0.039,0.219 0.059,0.389 0.059,0.513 0,0.117 -0.038,0.204 -0.113,0.26 -0.077,0.055 -0.238,0.084 -0.484,0.084 l -0.705,0.008 -0.067,0.068 0.025,0.21 0.067,0.075 C -1.604,-0.501 -0.723,-0.279 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,237.49211,498.26312)"
                id="g1076"
              >
                <path
                  id="circle2"
                  d="M 0,0 C 0.588,0.106 1.146,0.272 1.676,0.5 2.205,0.727 2.61,1.028 2.894,1.406 3.176,1.784 3.317,2.169 3.317,2.562 3.317,2.863 3.242,3.088 3.091,3.233 2.939,3.379 2.758,3.451 2.545,3.451 2.31,3.451 2.034,3.385 1.718,3.25 1.401,3.115 1.121,2.869 0.878,2.511 0.635,2.152 0.342,1.315 0,0 M 3.863,-2.192 3.956,-2.402 3.939,-2.511 C 2.562,-3.676 1.395,-4.258 0.437,-4.258 c -0.314,0 -0.632,0.085 -0.958,0.256 -0.324,0.171 -0.566,0.416 -0.726,0.735 -0.159,0.319 -0.239,0.728 -0.239,1.226 0,0.7 0.116,1.446 0.348,2.238 0.233,0.792 0.465,1.377 0.698,1.755 C -0.208,2.33 0.141,2.686 0.605,3.02 1.069,3.353 1.511,3.621 1.928,3.825 2.345,4.029 2.749,4.132 3.142,4.132 3.566,4.132 3.914,4.02 4.183,3.796 4.451,3.572 4.586,3.261 4.586,2.863 4.586,2.41 4.457,1.991 4.199,1.608 3.942,1.225 3.472,0.862 2.789,0.521 2.105,0.179 1.288,-0.101 0.336,-0.319 l -0.395,-0.092 c -0.112,-0.538 -0.168,-0.986 -0.168,-1.344 0,-0.504 0.113,-0.904 0.336,-1.201 0.224,-0.297 0.538,-0.445 0.941,-0.445 0.756,0 1.663,0.414 2.721,1.243 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,249.94227,495.70722)"
                id="g1080"
              >
                <path
                  id="circle2"
                  d="m 0,0 c 0,-0.353 0.098,-0.656 0.294,-0.911 0.196,-0.255 0.523,-0.382 0.982,-0.382 0.627,0 1.147,0.282 1.558,0.848 C 3.246,0.12 3.587,0.849 3.859,1.738 4.131,2.629 4.267,3.376 4.267,3.98 4.267,4.591 4.212,4.978 4.103,5.14 3.993,5.302 3.818,5.384 3.577,5.384 3.208,5.384 2.817,5.258 2.406,5.006 1.994,4.754 1.586,4.348 1.18,3.788 0.773,3.228 0.476,2.538 0.285,1.718 0.095,0.897 0,0.325 0,0 M 1.873,10.615 2.091,10.456 1.503,7.777 0.646,3.746 c 0.74,0.98 1.444,1.67 2.113,2.07 0.669,0.4 1.253,0.6 1.751,0.6 0.241,0 0.43,-0.062 0.571,-0.185 C 5.221,6.108 5.324,5.905 5.392,5.623 5.459,5.34 5.492,4.997 5.492,4.594 5.492,3.788 5.358,3.001 5.089,2.234 4.82,1.467 4.531,0.854 4.22,0.395 3.909,-0.064 3.565,-0.459 3.188,-0.789 2.81,-1.12 2.377,-1.405 1.89,-1.646 1.402,-1.887 0.935,-2.007 0.487,-2.007 c -0.476,0 -0.881,0.133 -1.214,0.399 -0.333,0.266 -0.5,0.609 -0.5,1.029 0,0.263 0.099,0.901 0.294,1.915 l 0.588,3.022 c 0.113,0.611 0.23,1.263 0.354,1.957 L 0.336,8.138 C 0.431,8.664 0.482,8.965 0.491,9.041 0.5,9.116 0.504,9.185 0.504,9.247 0.504,9.375 0.46,9.465 0.374,9.516 0.287,9.565 0.132,9.591 -0.093,9.591 l -0.705,0.009 -0.058,0.067 0.025,0.21 0.066,0.075 c 1.042,0.168 1.921,0.389 2.638,0.663"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,257.85001,500.89442)"
                id="g1084"
              >
                <path
                  id="circle2"
                  d="M 0,0 -0.084,0.193 -0.06,0.312 C 0.108,0.439 0.473,0.677 1.032,1.021 1.593,1.365 1.981,1.585 2.2,1.68 2.418,1.775 2.586,1.823 2.704,1.823 2.821,1.823 2.914,1.778 2.981,1.688 3.048,1.599 3.082,1.495 3.082,1.378 3.082,1.249 3.001,0.857 2.838,0.202 2.121,-2.737 1.764,-4.471 1.764,-4.996 c 0,-0.247 0.084,-0.37 0.252,-0.37 0.212,0 0.552,0.184 1.019,0.554 0.468,0.37 0.972,0.899 1.512,1.587 0.541,0.689 0.933,1.38 1.181,2.075 0.246,0.694 0.463,1.582 0.654,2.662 0.067,0.011 0.451,0.101 1.151,0.269 L 7.659,1.655 C 7.653,1.621 7.586,1.389 7.457,0.958 7.233,0.235 7.009,-0.596 6.785,-1.536 6.562,-2.477 6.399,-3.229 6.298,-3.791 6.197,-4.354 6.147,-4.753 6.147,-4.988 c 0,-0.263 0.089,-0.395 0.269,-0.395 0.095,0 0.213,0.043 0.353,0.13 0.139,0.087 0.456,0.316 0.949,0.685 L 7.81,-4.602 7.902,-4.795 7.886,-4.904 C 6.9,-5.683 6.255,-6.157 5.95,-6.327 5.645,-6.498 5.411,-6.584 5.248,-6.584 c -0.134,0 -0.239,0.061 -0.314,0.181 -0.076,0.12 -0.114,0.258 -0.114,0.416 0,0.346 0.236,1.497 0.705,3.451 L 5.476,-2.511 4.854,-3.4 C 4.641,-3.703 4.392,-4.019 4.106,-4.346 3.821,-4.673 3.486,-5.008 3.103,-5.35 2.719,-5.69 2.371,-5.96 2.058,-6.155 1.743,-6.352 1.517,-6.474 1.377,-6.521 1.237,-6.568 1.128,-6.592 1.05,-6.592 c -0.163,0 -0.305,0.079 -0.425,0.239 -0.12,0.16 -0.181,0.396 -0.181,0.709 0,0.432 0.11,1.089 0.328,1.974 0.554,2.223 0.832,3.572 0.832,4.048 0,0.18 -0.073,0.269 -0.218,0.269 -0.168,0 -0.597,-0.224 -1.285,-0.671 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,268.07491,493.95305)"
                id="g1088"
              >
                <path
                  id="circle2"
                  d="M 0,0 C 0.196,0.885 0.312,1.596 0.345,2.133 L 0.412,2.2 H 0.697 L 0.765,2.133 V 0.781 C 1.269,0.35 1.82,0.134 2.419,0.134 c 0.269,0 0.529,0.045 0.781,0.135 0.252,0.089 0.462,0.21 0.63,0.365 0.168,0.154 0.303,0.358 0.403,0.613 0.101,0.255 0.152,0.514 0.152,0.776 0,0.18 -0.035,0.354 -0.106,0.522 C 4.209,2.713 4.092,2.848 3.927,2.952 3.762,3.056 3.43,3.152 2.932,3.241 2.428,3.331 2.072,3.405 1.865,3.464 1.657,3.522 1.456,3.625 1.26,3.771 1.064,3.916 0.909,4.106 0.794,4.342 0.68,4.577 0.622,4.832 0.622,5.105 c 0,0.376 0.088,0.716 0.265,1.021 0.175,0.306 0.437,0.593 0.785,0.861 0.347,0.269 0.706,0.492 1.079,0.672 0.372,0.179 0.782,0.269 1.23,0.269 0.661,0 1.218,-0.135 1.671,-0.404 L 5.686,7.433 C 5.591,7.107 5.529,6.813 5.501,6.551 L 5.4,5.609 5.333,5.543 H 5.073 L 4.997,5.609 C 4.997,5.94 4.989,6.262 4.972,6.575 4.58,7.007 4.051,7.223 3.385,7.223 2.858,7.223 2.436,7.069 2.117,6.765 1.798,6.459 1.638,6.094 1.638,5.669 1.638,5.321 1.744,5.047 1.957,4.846 2.17,4.644 2.573,4.498 3.167,4.409 3.698,4.33 4.076,4.264 4.301,4.207 4.524,4.151 4.731,4.058 4.922,3.926 5.112,3.794 5.262,3.624 5.371,3.414 5.48,3.204 5.535,2.967 5.535,2.704 5.535,2.391 5.475,2.084 5.354,1.784 5.233,1.484 5.063,1.209 4.842,0.957 4.621,0.705 4.306,0.443 3.897,0.172 3.488,-0.1 3.127,-0.286 2.813,-0.387 2.5,-0.487 2.167,-0.538 1.814,-0.538 c -0.565,0 -1.159,0.148 -1.78,0.445 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,275.67768,493.95305)"
                id="g1092"
              >
                <path
                  id="circle2"
                  d="M 0,0 C 0.196,0.885 0.312,1.596 0.345,2.133 L 0.412,2.2 H 0.697 L 0.765,2.133 V 0.781 C 1.269,0.35 1.82,0.134 2.419,0.134 c 0.269,0 0.529,0.045 0.781,0.135 0.252,0.089 0.462,0.21 0.63,0.365 0.168,0.154 0.303,0.358 0.403,0.613 0.101,0.255 0.152,0.514 0.152,0.776 0,0.18 -0.035,0.354 -0.106,0.522 C 4.209,2.713 4.092,2.848 3.927,2.952 3.762,3.056 3.43,3.152 2.932,3.241 2.428,3.331 2.072,3.405 1.865,3.464 1.657,3.522 1.456,3.625 1.26,3.771 1.064,3.916 0.909,4.106 0.794,4.342 0.68,4.577 0.622,4.832 0.622,5.105 c 0,0.376 0.088,0.716 0.265,1.021 0.175,0.306 0.437,0.593 0.785,0.861 0.347,0.269 0.706,0.492 1.079,0.672 0.372,0.179 0.782,0.269 1.23,0.269 0.661,0 1.218,-0.135 1.671,-0.404 L 5.686,7.433 C 5.591,7.107 5.529,6.813 5.501,6.551 L 5.4,5.609 5.333,5.543 H 5.073 L 4.997,5.609 C 4.997,5.94 4.989,6.262 4.972,6.575 4.58,7.007 4.051,7.223 3.385,7.223 2.858,7.223 2.436,7.069 2.117,6.765 1.798,6.459 1.638,6.094 1.638,5.669 1.638,5.321 1.744,5.047 1.957,4.846 2.17,4.644 2.573,4.498 3.167,4.409 3.698,4.33 4.076,4.264 4.301,4.207 4.524,4.151 4.731,4.058 4.922,3.926 5.112,3.794 5.262,3.624 5.371,3.414 5.48,3.204 5.535,2.967 5.535,2.704 5.535,2.391 5.475,2.084 5.354,1.784 5.233,1.484 5.063,1.209 4.842,0.957 4.621,0.705 4.306,0.443 3.897,0.172 3.488,-0.1 3.127,-0.286 2.813,-0.387 2.5,-0.487 2.167,-0.538 1.814,-0.538 c -0.565,0 -1.159,0.148 -1.78,0.445 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,286.36294,506.15918)"
                id="g1096"
              >
                <path
                  id="circle2"
                  d="m 0,0 c 0,0.296 0.094,0.558 0.281,0.785 0.188,0.227 0.416,0.34 0.685,0.34 0.19,0 0.345,-0.059 0.462,-0.177 C 1.546,0.831 1.604,0.663 1.604,0.444 1.604,0.143 1.518,-0.128 1.344,-0.366 1.17,-0.604 0.952,-0.723 0.688,-0.723 0.493,-0.723 0.329,-0.655 0.197,-0.521 0.065,-0.387 0,-0.213 0,0 m -2.191,-4.687 -0.084,0.194 0.024,0.108 c 0.762,0.549 1.349,0.934 1.76,1.156 0.411,0.22 0.735,0.332 0.97,0.332 0.229,0 0.344,-0.166 0.344,-0.497 0,-0.151 -0.029,-0.365 -0.088,-0.642 -0.059,-0.276 -0.2,-0.835 -0.424,-1.675 -0.611,-2.263 -0.915,-3.601 -0.915,-4.015 0,-0.223 0.078,-0.336 0.235,-0.336 0.24,0 0.677,0.239 1.309,0.714 L 1.024,-9.373 1.117,-9.591 1.101,-9.692 c -0.393,-0.302 -0.795,-0.593 -1.21,-0.873 -0.414,-0.281 -0.709,-0.458 -0.886,-0.534 -0.177,-0.075 -0.323,-0.113 -0.441,-0.113 -0.168,0 -0.299,0.072 -0.395,0.218 -0.095,0.145 -0.143,0.316 -0.143,0.513 0,0.252 0.036,0.522 0.106,0.81 0.069,0.288 0.155,0.608 0.256,0.962 0.364,1.299 0.623,2.312 0.776,3.04 0.154,0.728 0.232,1.173 0.232,1.335 0,0.19 -0.065,0.285 -0.194,0.285 -0.084,0 -0.165,-0.02 -0.243,-0.062 -0.079,-0.042 -0.432,-0.245 -1.059,-0.61 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,289.60639,493.49513)"
                id="g1100"
              >
                <path
                  id="circle2"
                  d="m 0,0 -0.109,0.143 c 0.364,1.114 0.687,2.399 0.969,3.855 0.284,1.455 0.425,2.379 0.425,2.771 0,0.218 -0.076,0.328 -0.227,0.328 -0.207,0 -0.638,-0.222 -1.293,-0.664 l -0.101,0.025 -0.076,0.185 0.025,0.126 c 0.224,0.168 0.491,0.358 0.802,0.571 0.312,0.213 0.618,0.402 0.92,0.567 0.303,0.165 0.511,0.266 0.626,0.302 0.114,0.037 0.217,0.055 0.307,0.055 0.156,0 0.264,-0.055 0.323,-0.163 C 2.649,7.991 2.679,7.878 2.679,7.76 2.679,7.508 2.587,7.01 2.401,6.265 2.346,6.058 2.194,5.445 1.948,4.426 L 2.007,4.409 C 2.421,5.087 2.931,5.736 3.535,6.357 4.14,6.979 4.765,7.452 5.408,7.776 6.052,8.102 6.525,8.264 6.827,8.264 6.995,8.264 7.121,8.212 7.205,8.108 7.289,8.005 7.331,7.872 7.331,7.71 7.331,7.323 7.139,6.383 6.752,4.888 6.231,2.895 5.971,1.722 5.971,1.369 c 0,-0.207 0.076,-0.31 0.226,-0.31 0.186,0 0.656,0.268 1.411,0.805 L 7.701,1.839 7.793,1.621 7.769,1.521 C 7.421,1.24 7.023,0.953 6.575,0.659 6.128,0.365 5.803,0.174 5.602,0.084 5.399,-0.006 5.231,-0.051 5.098,-0.051 4.924,-0.051 4.797,0.01 4.716,0.13 4.634,0.251 4.594,0.4 4.594,0.579 c 0,0.196 0.045,0.503 0.134,0.92 0.089,0.417 0.277,1.183 0.563,2.297 0.408,1.573 0.612,2.539 0.612,2.897 0,0.297 -0.106,0.446 -0.318,0.446 C 5.434,7.139 5.257,7.091 5.056,6.996 4.697,6.828 4.311,6.555 3.896,6.177 3.482,5.799 3.103,5.356 2.759,4.85 2.414,4.343 2.146,3.839 1.952,3.338 1.759,2.837 1.59,2.271 1.444,1.638 1.422,1.56 1.335,1.103 1.184,0.269 0.798,0.207 0.403,0.117 0,0"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,301.38651,498.26312)"
                id="g1104"
              >
                <path
                  id="circle2"
                  d="M 0,0 C 0.588,0.106 1.146,0.272 1.676,0.5 2.205,0.727 2.61,1.028 2.894,1.406 3.176,1.784 3.317,2.169 3.317,2.562 3.317,2.863 3.242,3.088 3.091,3.233 2.939,3.379 2.758,3.451 2.545,3.451 2.31,3.451 2.034,3.385 1.718,3.25 1.401,3.115 1.121,2.869 0.878,2.511 0.635,2.152 0.342,1.315 0,0 M 3.863,-2.192 3.956,-2.402 3.939,-2.511 C 2.562,-3.676 1.395,-4.258 0.437,-4.258 c -0.314,0 -0.632,0.085 -0.958,0.256 -0.324,0.171 -0.566,0.416 -0.726,0.735 -0.159,0.319 -0.239,0.728 -0.239,1.226 0,0.7 0.116,1.446 0.348,2.238 0.233,0.792 0.465,1.377 0.698,1.755 C -0.208,2.33 0.141,2.686 0.605,3.02 1.069,3.353 1.511,3.621 1.928,3.825 2.345,4.029 2.749,4.132 3.142,4.132 3.566,4.132 3.914,4.02 4.183,3.796 4.451,3.572 4.586,3.261 4.586,2.863 4.586,2.41 4.457,1.991 4.199,1.608 3.942,1.225 3.472,0.862 2.789,0.521 2.105,0.179 1.288,-0.101 0.336,-0.319 l -0.395,-0.092 c -0.112,-0.538 -0.168,-0.986 -0.168,-1.344 0,-0.504 0.113,-0.904 0.336,-1.201 0.224,-0.297 0.538,-0.445 0.941,-0.445 0.756,0 1.663,0.414 2.721,1.243 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,307.17667,493.95305)"
                id="g1108"
              >
                <path
                  id="circle2"
                  d="M 0,0 C 0.196,0.885 0.312,1.596 0.345,2.133 L 0.412,2.2 H 0.697 L 0.765,2.133 V 0.781 C 1.269,0.35 1.82,0.134 2.419,0.134 c 0.269,0 0.529,0.045 0.781,0.135 0.252,0.089 0.462,0.21 0.63,0.365 0.168,0.154 0.303,0.358 0.403,0.613 0.101,0.255 0.152,0.514 0.152,0.776 0,0.18 -0.035,0.354 -0.106,0.522 C 4.209,2.713 4.092,2.848 3.927,2.952 3.762,3.056 3.43,3.152 2.932,3.241 2.428,3.331 2.072,3.405 1.865,3.464 1.657,3.522 1.456,3.625 1.26,3.771 1.064,3.916 0.909,4.106 0.794,4.342 0.68,4.577 0.622,4.832 0.622,5.105 c 0,0.376 0.088,0.716 0.265,1.021 0.175,0.306 0.437,0.593 0.785,0.861 0.347,0.269 0.706,0.492 1.079,0.672 0.372,0.179 0.782,0.269 1.23,0.269 0.661,0 1.218,-0.135 1.671,-0.404 L 5.686,7.433 C 5.591,7.107 5.529,6.813 5.501,6.551 L 5.4,5.609 5.333,5.543 H 5.073 L 4.997,5.609 C 4.997,5.94 4.989,6.262 4.972,6.575 4.58,7.007 4.051,7.223 3.385,7.223 2.858,7.223 2.436,7.069 2.117,6.765 1.798,6.459 1.638,6.094 1.638,5.669 1.638,5.321 1.744,5.047 1.957,4.846 2.17,4.644 2.573,4.498 3.167,4.409 3.698,4.33 4.076,4.264 4.301,4.207 4.524,4.151 4.731,4.058 4.922,3.926 5.112,3.794 5.262,3.624 5.371,3.414 5.48,3.204 5.535,2.967 5.535,2.704 5.535,2.391 5.475,2.084 5.354,1.784 5.233,1.484 5.063,1.209 4.842,0.957 4.621,0.705 4.306,0.443 3.897,0.172 3.488,-0.1 3.127,-0.286 2.813,-0.387 2.5,-0.487 2.167,-0.538 1.814,-0.538 c -0.565,0 -1.159,0.148 -1.78,0.445 z"
                ></path>
              </g>
              <g
                transform="matrix(1.1358601,0,0,1.1354533,320.72271,502.63087)"
                id="g1112"
              >
                <path
                  id="circle2"
                  d="m 0,0 -0.135,0.117 c 0.393,0.599 0.665,1.08 0.82,1.445 0.154,0.364 0.314,0.893 0.482,1.587 L 1.293,3.695 C 2.077,3.902 2.581,4.053 2.805,4.148 L 2.99,3.922 C 2.368,2.595 1.557,1.346 0.555,0.176 Z m -3.267,0 -0.134,0.117 c 0.391,0.599 0.666,1.08 0.823,1.445 0.156,0.364 0.316,0.893 0.478,1.587 l 0.135,0.546 c 0.778,0.207 1.282,0.358 1.512,0.453 L -0.277,3.922 C -0.893,2.595 -1.705,1.346 -2.713,0.176 Z"
                ></path>
              </g>
            </g>
          </svg>
        </div>
        <div class="flex items-center justify-center p-6 sm:p-12 md:w-1/2">
          <div class="w-full">
            <h1
              class="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200"
            >
              Login
            </h1>
            <form v-on:submit.prevent="login()">
              <label class="block text-sm text-left">
                <span class="text-gray-700 dark:text-gray-400">Email</span>
                <input
                  required="required"
                  class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 border-2 border-gray-300 focus:outline-none focus:ring-2 focus:border-blue-300 rounded-sm p-2 dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="User"
                  v-model="userName"
                />
              </label>
              <label class="block mt-4 text-sm text-left">
                <span class="text-gray-700 dark:text-gray-400">Password</span>
                <input
                  required="required"
                  class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 border-2 border-gray-300 focus:outline-none focus:ring-2 focus:border-blue-300 rounded-sm p-2 dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="***************"
                  type="password"
                  v-model="password"
                />
              </label>
              <label
                v-show="errorLogin === true"
                class="block mt-2 w-full p-2 bg-red-300 text-white font-bold text-sm"
                >{{ errorMessage }}</label
              >
              <!-- You should use a button here, as the anchor is only used for the example  -->
              <button
                v-if="loading === false"
                type="submit"
                class="block w-full px-4 py-2 mt-4 text-sm font-medium leading-5 text-center text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-blue-600 hover:bg-blue-700 focus:outline-none focus:shadow-outline-purple"
              >
                Log in
              </button>
              <button
                v-if="loading === true"
                type="button"
                disabled
                class="cursor-not-allowed block w-full px-4 py-2 mt-4 text-sm font-medium leading-5 text-center text-white transition-colors duration-150 bg-blue-500 border border-transparent rounded-lg focus:outline-none focus:shadow-outline-purple"
              >
                <i class="icon-arrows-cw animate-pulse"></i>
                Processing
              </button>
            </form>
            <hr class="my-8" />

            <!-- <button
						class="flex items-center justify-center w-full px-4 py-2 text-sm font-medium leading-5  text-gray-700 transition-colors duration-150 border border-gray-300 rounded-lg dark:text-gray-400 active:bg-transparent hover:border-gray-500 focus:border-gray-500 active:text-gray-500 focus:outline-none focus:shadow-outline-gray"
					>
						<svg
						class="w-4 h-4 mr-2"
						aria-hidden="true"
						viewBox="0 0 24 24"
						fill="currentColor"
						>
						<path
							d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
						/>
						</svg>
						Github
					</button>
					<button
						class="flex items-center justify-center w-full px-4 py-2 mt-4 text-sm font-medium leading-5  text-gray-700 transition-colors duration-150 border border-gray-300 rounded-lg dark:text-gray-400 active:bg-transparent hover:border-gray-500 focus:border-gray-500 active:text-gray-500 focus:outline-none focus:shadow-outline-gray"
					>
						<svg
						class="w-4 h-4 mr-2"
						aria-hidden="true"
						viewBox="0 0 24 24"
						fill="currentColor"
						>
						<path
							d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z"
						/>
						</svg>
						Twitter
					</button> -->

            <p class="mt-4">
              <a
                class="text-sm font-medium text-blue-500 dark:text-purple-400 hover:underline"
                href=""
              >
                Forgot your password?
              </a>
            </p>
            <!-- <p class="mt-1">
						<a
						class="text-sm font-medium text-blue-500 dark:text-purple-400 hover:underline"
						href="./create-account.html"
						>
						Create account
						</a>
					</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import router from "@/router";
import { mapMutations } from "vuex";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      loading: false,
      errorLogin: false,
      URL: process.env.VUE_APP_URL,
      userName: "",
      password: "",
      errorMessage: "",
    };
  },
  methods: {
    ...mapMutations(["getUserToken"]),
    async login() {
      this.loading = true;
      const URL = `${this.URL}login`;
      const URLYEAR = `${process.env.VUE_APP_URL_ACC}show-active-company-config`;
      const fetchConfig = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      console.log(URL);
      const params = {
        userName: this.userName,
        password: this.password,
      };
      
      try {
        

        let login = await Axios.post(URL, params, fetchConfig);

        const params2 = {
          company_id: login.data.data.user.companyId,
        };
        let yearActive = await Axios.post(URLYEAR, params2, fetchConfig);
        
        // console.log('login.data.data');
        // console.log(login.data.data.user.companyId);
        // console.log('yearActive');
        // console.log(yearActive.data.data.current_year);
        // return
        if (login.statusText === "OK" && yearActive.statusText === "OK") {
          this.getUserToken([login.data.data, yearActive.data.data.current_year]);
          // cambio la url, para cargar la HOME, despues q se ejecute window.location.reload()
          router.push({ name: "Home", path: "/", params: login.data.data });
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      } catch (error) {
        this.loading = false;
        if (error.message == "Network Error") {
          // console.log(error.message);
          this.errorLogin = true;
          this.errorMessage = error.message;
          return;
        }
        if (error.message == "Request failed with status code 401") {
          this.errorLogin = true;
          this.errorMessage = "No autorizado";
        } else {
          this.errorMessage = error.message;
        }
      }
    },
  },
};
</script>

<style></style>
